/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').factory('SaleView', ["$log", "$filter", "$dialog", "SiteData", "Payment", "SaleData", "DaySrv", "SaleProductView",
    "SaleServiceView", "SaleCureView", "LoyaltyCardItemView", "LoyaltyCardItemData", "Transaction", "SaleSrv", "Sale",
    "CustomerView", "DayView", "BookingData", "DayData", "SaleServiceData", "SaleProductData", "SaleCureData",
    "GiftItemView", "GiftItemData", "PaymentView", "Day", "HumanResourceData", "CurrencyManager", "NumberSeparatorType",
    "gettextCatalog", "IOSDevice", "Countries", "SaleStatus", "SalePaymentType", "BookingSaveTransactionOrigin",
    "SalePaymentTypeFactory", "BasicAuthRoleFactory", "PaymentDataObject", "SaleSettings", "SalePartnerSettingsFactory",
    "Brand", "LaunchDarklyFeatureFlagData", "Site", "SlackSrv", "NfConstant",
    function ($log, $filter, $dialog, SiteData, Payment, SaleData, DaySrv, SaleProductView,
              SaleServiceView, SaleCureView, LoyaltyCardItemView, LoyaltyCardItemData, Transaction, SaleSrv, Sale,
              CustomerView, DayView, BookingData, DayData, SaleServiceData, SaleProductData, SaleCureData,
              GiftItemView, GiftItemData, PaymentView, Day, HumanResourceData, CurrencyManager, NumberSeparatorType,
              gettextCatalog, IOSDevice, Countries, SaleStatus, SalePaymentType, BookingSaveTransactionOrigin,
              SalePaymentTypeFactory, BasicAuthRoleFactory, PaymentDataObject, SaleSettings, SalePartnerSettingsFactory,
              Brand, LaunchDarklyFeatureFlagData, Site, SlackSrv, NfConstant) {

        var SaleView = function (sale, saleIndex, dayView, bookingView, posView) {
            this.saleIndex = -1;
            this.dayView = dayView;
            this.bookingView = bookingView;
            this.status = "created";//created,estimation,waiting,advance,advanceProcess,advanceKeeped,soldProcess,canceled,credit  or sold
            this.isCreatedByCustomer = false;
            this.nbPrint = 0;
            this.posView = posView;
            this.displayGiftItemMailRecipientError = false;
            this.saleNumber = null;
            this.advanceNumber = null;
            this.estimationNumber = null;
            this.signatureCode = null;
            this.canceledSaleNumber = null;
            this.dayId = null;
            this.timeCreated = new Date();
            this.customerView = null;
            this.isOccasionalCustomer = false;
            this.customerLabel = "";
            this.vat = null;  //default percent
            this.vatCode = null;  //default code
            this.servicesPrice = 0;//TTC sum of service
            this.productsPrice = 0;//TTC sum of service
            this.curesPrice = 0;//TTC sum of service
            this.giftItemsPrice = 0;//TTC sum of giftItems
            this.loyaltyCardsPrice = 0;//TTC sum of loyaltyCardItems
            this.servicesPriceWithD = 0;//TTC sum of service with global discount
            this.productsPriceWithD = 0;
            this.curesPriceWithD = 0;
            this.giftItemsPriceWithD = 0;
            this.loyaltyCardsPriceWithD = 0;
            this.price = 0;
            this.priceInput = "";
            this.priceHT = 0;
            this.discountPercent = 0;
            this.change = 0;  //only for view
            this.saleServicesView = []; // saleServices View
            this.saleProductsView = []; // saleProducts View
            this.saleCuresView = []; // saleCures View
            this.giftItemsView = [];
            this.loyaltyCardItemsView = [];
            this.currentPayment = 0; //only for view
            this.advancePercent = posView && posView.domainView && posView.domainView.advancePercent ? posView.domainView.advancePercent : 30; //only for view
            this.paymentsView = []; //Payment type
            this.cancelReason = "";
            this.copyOnCancel = false; // used on cancel form to know if a new ticket must be created from current
            this.refundOnCancel = true; // used on cancel form to know if a online ticket must be refund
            this.transformToGiftOnCancel = true; // used on cancel form to know if a online ticket must be changed to gift
            this.creditDayView = false; // used on cancel form to display a date confirmation for credit
            this.creditDateAsSale = true; // used on cancel form to know if the credit date must be equal to sale date or today
            this.isReadOnly = false;
            this.hasGiftItems = false;
            this.payedPrice = 0;
            this.paymentCardId;
            this.oriSaleMinView = null;
            this.vatLines = []; // list of taxes applied (only on view)  {tax,amount}
            this.loyaltyCardItemView = null//imputed card
            this.nbLoyaltyCardGoal = 0;
            this.loyaltyPts = 0;
            this.loyaltyUsedPts = 0;
            this.loyaltyDate = null;
            this.loyaltyDiscount = 0;
            this.hasLoyaltyDiscount = false;
            this.isValidLoyaltyPoints = true;
            this.hasUnpaid = false;
            this.delivery = null;  //address
            this.deliveryMsg = null;
            this.productsOfServicesView = [];
            this.hrSellerView = null;
            this.hrOpView = null;
            this.techNotes = null;
            this.isCommentVisible = false;
            this.comment = null;
            this.sendByMail = false;
            this.sendGiftByMail = false;
            this.hasInvalidAmounts = false;
            this.customerLastname = null;
            this.customerFirstname = null;
            this.customerAddress = null;
            this.customerZip = null;
            this.customerCity = null;
            this.shareCapital = null;
            this.greffeCity = null;
            this.juridicForm = null;
            this.canAccessBookingUserStory = LaunchDarklyFeatureFlagData.canAccessBookingUserStory;
            this.form = {
                displayError: false,
                displayErrorGiftItem: false,
                displayErrorMobile: false,
                displayErrorCustomer: false,
                displayErrorLandLine: false,
                displayErrorPrice: false,
                displayChangeMsg: false,
                displayCustomerButton: null,
                displayMoreFields: false,
                displayOverPaymentError: false,
                displayGlobalDiscount: false,
                displayOtherActions: false,
                canChangeFuturePayment: false,
                displayErrorCurrentPayment: false,
                nbPayments: 1,
                paymentActionsTab: 0, // 0 = menu OtherActions; 1 = subMenu multiplePayment; 2 = subMenu multipleType; 3 = subMenu returnMoney
                titleOtherActions: ""
            }
            //For view only
            this.paymentsForADate = new PaymentDataObject();
            this.paymentsForADate.otherPaymentTypePrices = [];
            this.paymentsForADate.price = 0;
            this.paymentsForADate.priceHT = 0;
            this.paymentsForADate.hasSamePriceThanSale = false;
            this.paymentsForADate.hasSpecificPaymentDate = false;
            this.paymentsForADate.paymentNumber = 1;//for a date
            this.paymentsForADate.nbPayments = 1;//for dates

            this.printWindow = null;
            this.softV = null;
            this.totalLoyaltyPts = 0;
            this.hasLoyaltyDiscount = false;
            this.advancePrice = 0;
            this.site = null;

            this.loadDataFrom(sale);
            if (saleIndex !== undefined)
                this.saleIndex = saleIndex;

            this.originalAdvanceLabel = gettextCatalog.getString("Imprimer un reçu");
            this.originalSaleLabel = gettextCatalog.getString("Enregistrer et imprimer le ticket");
            this.advanceDuplicataLabel = gettextCatalog.getString("Imprimer duplicata n°");
            this.saleDuplicataLabel = gettextCatalog.getString("Enregistrer et imprimer duplicata n°");
            this.printLabel = gettextCatalog.getString("Imprimer");
            this.saleSettings = SaleSettings;
            this.basicAuthRoleFactory = BasicAuthRoleFactory;
            this.basicAuthRole = null;
            this.canRefundGiftItem = false;
            this.statusLabel = {
                sold: "Encaissé",
                credit: "Crédit d'annulation"
            }
        };

        SaleView.prototype.loadDataFrom = function (sale) {
            if (sale) {
                this.loadPropertiesDataFrom(sale);
                this.loadSaleServicesDataFrom(sale);
                this.loadSaleProductsDataFrom(sale);
                this.loadSaleCuresDataFrom(sale);
                this.loadGiftItemsDataFrom(sale);
                this.loadLoyaltyCardItemsDataFrom(sale);

            }
            this.calculateSaleFields();
        };

        SaleView.prototype.displayError = function () {
            if ((this.customerView == null || this.customerView == undefined) && !this.isOccasionalCustomer) {
                this.form.displayErrorCustomer = true;
            }
            if (this.giftItemsView.length === 0) {
                this.form.displayErrorGiftItem = true;
            }

            this.form.displayError = true;
        };

        SaleView.prototype.displayErrorCurrentPayment = function () {
            if (this.currentPayment < 0) {
                this.form.displayErrorCurrentPayment = true;
            } else {
                this.form.displayError = true;
            }
        };

        SaleView.prototype.loadPropertiesDataFrom = function (sale) {
            if (sale) {
                this.id = sale.id;
                this.saleNumber = sale.saleNumber;
                this.advanceNumber = sale.advanceNumber;
                this.estimationNumber = sale.estimationNumber;
                this.customerLastname = sale.customerLastname;
                this.customerFirstname = sale.customerFirstname;
                this.customerAddress = sale.customerAddress;
                this.customerZip = sale.customerZip;
                this.customerCity = sale.customerCity;
                this.shareCapital = sale.shareCapital;
                this.greffeCity = sale.greffeCity;
                this.juridicForm = sale.juridicForm;
                this.signatureCode = sale.signatureCode;
                this.canceledSaleNumber = sale.canceledSaleNumber;
                this.vat = sale.vat;
                this.vatCode = sale.vatCode;
                this.servicesPrice = sale.servicesPrice;
                this.productsPrice = sale.productsPrice;
                if (sale.curesPrice)
                    this.curesPrice = sale.curesPrice;
                if (sale.giftItemsPrice)
                    this.giftItemsPrice = sale.giftItemsPrice;
                if (sale.loyaltyCardsPrice)
                    this.loyaltyCardsPrice = sale.loyaltyCardsPrice;
                this.price = sale.price;
                this.priceInput = $filter('currencyFormatFilter')(this.price);
                this.priceHT = sale.priceHT;
                this.discountPercent = sale.discountPercent;
                this.productsPriceWithD = this.productsPrice - this.productsPrice * this.discountPercent / 100;
                this.servicesPriceWithD = this.servicesPrice - this.servicesPrice * this.discountPercent / 100;
                this.curesPriceWithD = this.curesPrice - this.curesPrice * this.discountPercent / 100;
                this.giftItemsPriceWithD = this.giftItemsPrice - this.giftItemsPrice * this.discountPercent / 100;
                this.loyaltyCardsPriceWithD = this.loyaltyCardsPrice - this.loyaltyCardsPrice * this.discountPercent / 100;
                this.paymentsView = [];
                this.timeCreated = sale.timeCreated;
                this.cancelReason = sale.cancelReason;
                this.isCreatedByCustomer = sale.isCreatedByCustomer;
                this.nbPrint = sale.nbPrint;
                this.delivery = sale.delivery;
                this.deliveryMsg = sale.deliveryMsg;
                this.techNote = sale.techNote;
                this.comment = sale.comment;
                this.totalLoyaltyPts = sale.totalLoyaltyPts;
                this.site = sale.site;
                this.hasLoyaltyDiscount = sale.hasLoyaltyDiscount;
                this.setStatus(sale.status);
                if (sale.giftItems && sale.giftItems.length > 0) {
                    this.hasGiftItems = true;
                }
                this.softV = sale.softV;
                this.advancePrice = sale.advancePrice;

                if (sale.hrSeller && this.posView)
                    this.hrSellerView = this.posView.domainView.getHrView(sale.hrSeller);
                if (sale.hrOp && this.posView)
                    this.hrOpView = this.posView.domainView.getHrView(sale.hrOp);

                let paymentView, saleView;
                if (sale.customer) {
                    if (this.posView && this.posView.domainView)
                        this.customerView = this.posView.domainView.getCustomerView(sale.customer);
                    this.updateCustomerLabel();
                } else
                    this.isOccasionalCustomer = true;


                this.hasUnpaid = false;
                if (sale.payments) {

                    for (let i = 0; i < sale.payments.length; i++) {
                        saleView = null;
                        paymentView = new PaymentView(sale.payments[i], this);
                        if (sale.payments[i].giftItem) {
                            if (this.customerView)
                                paymentView.giftItemView = this.customerView.getGiftItemView(sale.payments[i].giftItem);

                            if (!paymentView.giftItemView) {
                                if (sale.payments[i].giftItem.sale && this.posView)
                                    saleView = new SaleView(sale.payments[i].giftItem.sale, SaleData.getIndexOf(sale.payments[i].giftItem.sale), null, null, null);//don't set this.posView in order to not load related data to avoid loop on booking
                                paymentView.giftItemView = new GiftItemView(sale.payments[i].giftItem, GiftItemData.getIndexOf(sale.payments[i].giftItem), -1, saleView);
                            }
                            if (this.status !== "canceled" && this.status !== "credit") //link only to a giftItem of sale sold or waiting
                                paymentView.giftItemView.paymentSaleView = this;
                        }
                        this.form.canChangeFuturePayment = this.form.canChangeFuturePayment || paymentView.canChange;
                        if (paymentView.type === "UNPAID")
                            this.hasUnpaid = true;
                        this.paymentsView.push(paymentView);
                    }
                }


                if (sale.oriSale)
                    this.oriSaleMinView = {saleIndex: SaleData.getIndexOf(sale.oriSale), saleNumber: sale.oriSale.saleNumber};
                if (sale.booking && !this.bookingView)//not created by Booking view
                {
                    let bookingIndex = BookingData.getIndexOf(sale.booking);
                    if (sale.booking.day) {
                        let bPlgDayView = null;
                        let plgBookingView = null;
                        let bDayIndex = DayData.getIndexOf(sale.booking.day);
                        if (this.posView && this.posView.domainView.pTView && this.posView.domainView.pTView.getPlgDayViewByDayIndex !== undefined)
                            bPlgDayView = this.posView.domainView.pTView.getPlgDayViewByDayIndex(bDayIndex, true);
                        if (bPlgDayView)
                            plgBookingView = bPlgDayView.getBookingViewByIndex(bookingIndex, true);
                        if (plgBookingView) {
                            this.bookingView = plgBookingView;
                        }
                    }
                }
                let allItemsPrice = sale.getAllItemsPrice();
                if (sale.status === "waiting" || sale.status === "advance") {
                    if (sale.loyaltyCardItem) {
                        this.loyaltyCardItemView = new LoyaltyCardItemView(sale.loyaltyCardItem, LoyaltyCardItemData.getIndexOf(sale.loyaltyCardItem), 0, null, this.posView);
                        this.calculateUsedLoyaltyPts(allItemsPrice);
                        this.updateLoyaltyCardItemAction(false);
                    }
                    this.updateLoyaltyCardItemAction(false);

                } else {
                    if (sale.loyaltyCardItem) {
                        this.loyaltyCardItemView = new LoyaltyCardItemView(sale.loyaltyCardItem, LoyaltyCardItemData.getIndexOf(sale.loyaltyCardItem), 0, null, this.posView);
                        this.loyaltyDate = sale.loyaltyDate;
                        this.loyaltyPts = sale.loyaltyPts;
                        this.hasLoyaltyDiscount = sale.hasLoyaltyDiscount;
                        if (this.loyaltyPts < 0) {
                            //nbLoyaltyCardGoal get a positive value for parameter loyaltyPoints.
                            let hasLoyaltyCardInShoppingCart = this.loyaltyCardItemsView.length > 0;
                            this.nbLoyaltyCardGoal = this.loyaltyCardItemView.nbLoyaltyCardGoal(allItemsPrice, -this.loyaltyPts, hasLoyaltyCardInShoppingCart);
                        }
                    }
                }
            }
        };

        SaleView.prototype.loadSaleServicesDataFrom = function (sale) {
            if (sale) {
                let bsV;
                this.saleServicesView = [];
                for (let i = 0; i < sale.saleServices.length; i++) {
                    bsV = new SaleServiceView(sale.saleServices[i], SaleServiceData.getIndexOf(sale.saleServices[i]), i + 1, this);
                    this.saleServicesView.push(bsV);
                }
            }
        };

        SaleView.prototype.loadSaleProductsDataFrom = function (sale) {
            if (sale) {
                let bsV;
                this.saleProductsView = [];
                for (let i = 0; i < sale.saleProducts.length; i++) {
                    bsV = new SaleProductView(sale.saleProducts[i], SaleProductData.getIndexOf(sale.saleProducts[i]), i + 1, this);
                    this.saleProductsView.push(bsV);
                }
            }
        };

        SaleView.prototype.loadSaleCuresDataFrom = function (sale) {
            if (sale) {
                let bsV;
                this.saleCuresView = [];
                for (let i = 0; i < sale.saleCures.length; i++) {
                    bsV = new SaleCureView(sale.saleCures[i], SaleCureData.getIndexOf(sale.saleCures[i]), this.saleProductsView.length + i + 1, this);
                    this.saleCuresView.push(bsV);
                }
            }
        };

        SaleView.prototype.getProductsOfServices = function () {
            let productsOfServicesView = [];
            for (let i = 0; i < this.saleServicesView.length; i++) {
                if (this.saleServicesView[i].serviceView) {
                    for (let j = 0; j < this.saleServicesView[i].serviceView.productsView.length; j++)
                        if (this.saleServicesView.indexOf(this.saleServicesView[i].serviceView.productsView[j]))
                            productsOfServicesView.push(this.saleServicesView[i].serviceView.productsView[j]);
                }

            }
            return productsOfServicesView;
        };

        SaleView.prototype.loadLoyaltyCardItemsDataFrom = function (sale) {
            if (sale) {
                let loyaltyCardItemView;
                this.loyaltyCardItemsView = [];
                for (let i = 0; i < sale.loyaltyCardItems.length; i++) {
                    loyaltyCardItemView = new LoyaltyCardItemView(sale.loyaltyCardItems[i],
                        LoyaltyCardItemData.getIndexOf(sale.loyaltyCardItems[i]),
                        this.saleProductsView.length + this.saleCuresView.length + this.giftItemsView.length + i + 1, this);
                    this.loyaltyCardItemsView.push(loyaltyCardItemView);
                }
                if (this.status === SaleStatus.WAITING && !this.loyaltyDate && loyaltyCardItemView) {
                    this.loyaltyDate = loyaltyCardItemView.validityDate;
                }
            }
        };

        SaleView.prototype.loadGiftItemsDataFrom = function (sale) {
            if (sale) {
                let bsV;
                this.giftItemsView = [];
                for (let i = 0; i < sale.giftItems.length; i++) {
                    bsV = new GiftItemView(sale.giftItems[i], GiftItemData.getIndexOf(sale.giftItems[i]), this.saleProductsView.length + this.saleCuresView.length + i + 1, this);
                    this.giftItemsView.push(bsV);
                }
            }
        };

        SaleView.prototype.updateCustomerLabel = function () {
            if (this.customerView) {
                this.customerLabel = this.customerView.lastName;
                if (this.customerView.firstName)
                    this.customerLabel = +" " + this.customerView.firstName;

            }
        };

        SaleView.prototype.copyDataTo = function (sale, previousStatus) {
            sale.canceledSaleNumber = this.canceledSaleNumber;
            sale.vat = this.vat;
            sale.vatCode = this.vatCode;
            sale.price = this.price;
            sale.servicesPrice = this.servicesPrice;
            sale.productsPrice = this.productsPrice;
            sale.curesPrice = this.curesPrice;
            sale.giftItemsPrice = this.giftItemsPrice;
            sale.loyaltyCardsPrice = this.loyaltyCardsPrice;
            this.updateSellerFromItems();
            sale.hrSeller = this.hrSellerView;
            sale.priceHT = this.priceHT;
            sale.status = this.status;
            sale.delivery = this.delivery;
            sale.deliveryMsg = this.deliveryMsg;
            if (this.techNote === '') {
                this.techNote = null;
            }
            sale.techNote = this.techNote;
            sale.comment = this.comment;
            sale.isCreatedByCustomer = this.isCreatedByCustomer;
            sale.nbPrint = this.nbPrint;
            sale.timeCreated = this.timeCreated;
            sale.sendByMail = this.sendByMail;
            sale.sendGiftByMail = this.sendGiftByMail;
            if (this.discountPercent && typeof this.discountPercent === 'string') {
                sale.discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
                sale.discountPercent = parseFloat(sale.discountPercent);
            } else {
                sale.discountPercent = this.discountPercent;
            }
            sale.cancelReason = this.cancelReason;
            sale.paymentCardId = this.paymentCardId;
            sale.totalLoyaltyPts = this.totalLoyaltyPts;
            sale.site = this.site;
            sale.hasLoyaltyDiscount = this.hasLoyaltyDiscount;

            if (this.hrSellerView) {
                sale.hrSeller = this.hrSellerView.getModel();
            }
            if (this.hrOpView) {
                sale.hrOp = this.hrOpView.getModel();
            }

            //remove usage
            for (let i = 0; i < sale.payments.length; i++) {
                if (sale.payments[i].giftItem) {
                    sale.payments[i].giftItem.paymentSale = null;
                    if (!sale.booking || !sale.booking.containsGiftOnBs(sale.payments[i].giftItem)) {
                        sale.payments[i].giftItem.isUsed = false;
                    }
                }
            }
            sale.payments = [];
            for (let i = 0; i < this.paymentsView.length; i++) {
                let payment = new Payment();
                this.paymentsView[i].copyDataTo(payment);
                sale.payments.push(payment);
                this.form.canChangeFuturePayment = this.form.canChangeFuturePayment || this.paymentsView[i].canChange;
            }
            sale.updateRealPaymentPrice();
            //set usage
            let initCustomerGiftItems = false;
            if (this.status === SaleStatus.CREATED || this.status === SaleStatus.SOLD) {
                for (let i = 0; i < sale.payments.length; i++) {
                    if (sale.payments[i].giftItem) {
                        sale.payments[i].giftItem.isUsed = true;
                        sale.payments[i].giftItem.paymentSale = sale;
                        initCustomerGiftItems = true;
                    }
                }
            }
            if (this.bookingView) {
                let booking = this.bookingView.getModel();
                if (booking !== sale.booking) {
                    if (booking && this.status !== "canceled" && this.status !== "credit") { //no link from booking for this status
                        booking.sale = sale;
                    }
                    sale.booking = booking;
                }
            }

            sale.loyaltyPts = this.loyaltyPts + this.loyaltyUsedPts;
            sale.hasLoyaltyDiscount = this.hasLoyaltyDiscount;
            sale.loyaltyDate = this.loyaltyDate;
            if (this.loyaltyCardItemView) {
                sale.loyaltyCardItem = this.loyaltyCardItemView.getModel();
                if (sale.loyaltyCardItem) {
                    if (this.status === "sold" && previousStatus !== "sold") {
                        sale.loyaltyCardItem.pts += sale.loyaltyPts;
                        sale.loyaltyCardItem.validityDate = sale.loyaltyDate;
                        this.loyaltyCardItemView.pts += (this.loyaltyPts + this.loyaltyUsedPts);//for print
                    } else if (this.status === "canceled") {
                        sale.loyaltyCardItem.pts -= sale.loyaltyPts;
                        this.loyaltyCardItemView.pts -= (this.loyaltyPts + this.loyaltyUsedPts);
                    }
                }
            } else {
                sale.loyaltyCardItem = null;
            }

            if (this.customerView || this.isOccasionalCustomer) {
                let customer = (this.customerView ? this.customerView.getModel() : null);
                if (customer !== sale.customer) {
                    if (sale.customer) {
                        sale.customer.removeSale(sale);
                        if (this.posView && this.posView.domainView) {
                            let previousCustomerView = this.posView.domainView.getCustomerView(sale.customer);
                            if (previousCustomerView) {
                                previousCustomerView.initHistoryView();
                            }
                        }
                    }
                    if (customer) {
                        customer.addSale(sale);
                    }
                    sale.customer = customer;
                }
                if (this.customerView) {
                    this.customerView.initHistoryView();
                    if (initCustomerGiftItems) {
                        this.customerView.initGiftItemsView();
                    }
                }
            }
            if (this.oriSaleMinView && this.oriSaleMinView.saleIndex !== -1) {
                sale.oriSale = SaleData.getByIndex(this.oriSaleMinView.saleIndex);
            }
            if (this.dayView) {
                sale.day = this.dayView.getModel();
            }
            sale.advancePrice = this.advancePrice;
        };

        SaleView.prototype.getModel = function () {
            if (this.saleIndex !== -1)
                return SaleData.getByIndex(this.saleIndex);
            return null;
        };

        SaleView.prototype.getClone = function (dayView) {
            let saleView = new SaleView(null, -1, dayView, this.bookingView, this.posView);
            saleView.vat = this.vat;
            saleView.vatCode = this.vatCode;
            saleView.price = this.price;
            saleView.priceInput = this.priceInput;
            saleView.servicesPrice = this.servicesPrice;
            saleView.productsPrice = this.productsPrice;
            saleView.curesPrice = this.curesPrice;
            saleView.giftItemsPrice = this.giftItemsPrice;
            saleView.loyaltyCardsPrice = this.loyaltyCardsPrice;
            saleView.servicesPriceWithD = this.servicesPriceWithD;
            saleView.productsPriceWithD = this.productsPriceWithD;
            saleView.curesPriceWithD = this.curesPriceWithD;
            saleView.giftItemsPriceWithD = this.giftItemsPriceWithD;
            saleView.loyaltyCardsPriceWithD = this.loyaltyCardsPriceWithD;
            saleView.priceHT = this.priceHT;
            saleView.status = this.status;
            saleView.customerView = this.customerView;
            saleView.customerLabel = this.customerLabel;
            saleView.isOccasionalCustomer = this.isOccasionalCustomer;
            saleView.change = this.change;  //only for view
            saleView.currentPayment = this.currentPayment; //only for view
            saleView.discountPercent = this.discountPercent;
            saleView.payedPrice = this.payedPrice;
            saleView.site = this.site;
            saleView.totalLoyaltyPts = this.totalLoyaltyPts;
            saleView.hasLoyaltyDiscount = this.hasLoyaltyDiscount;
            saleView.advancePrice = this.advancePrice;
            saleView.paymentsView = [];

            for (let i = 0; i < this.paymentsView.length; i++)
                if (this.paymentsView[i].type !== "CBONLINE")
                    saleView.paymentsView.push(this.paymentsView[i].getClone(saleView));

            for (let i = 0; i < this.saleServicesView.length; i++)
                saleView.addSaleServiceView(this.saleServicesView[i].getClone(saleView), false);

            for (let i = 0; i < this.saleProductsView.length; i++)
                saleView.addSaleProductView(this.saleProductsView[i].getClone(saleView), false);


            for (let i = 0; i < this.saleCuresView.length; i++)
                saleView.addSaleCureView(this.saleCuresView[i].getClone(saleView), false);

            for (let i = 0; i < this.giftItemsView.length; i++)
                saleView.addGiftItemView(this.giftItemsView[i].getClone(saleView), false);

            for (let i = 0; i < this.loyaltyCardItemsView.length; i++)
                saleView.addLoyaltyCardItemView(this.loyaltyCardItemsView[i].getClone(saleView), false);

            return saleView;
        };

        SaleView.prototype.initFromBookingView = function (bookingView) {
            bookingView.saleView = this;
            this.customerView = bookingView.customerView;
            this.isOccasionalCustomer = bookingView.isOccasionalCustomer;
            //manage payments for bookingService linked to giftitem

            for (let i = 0; i < bookingView.bookingServicesView.length; i++) {
                let currentBSView = bookingView.bookingServicesView[i];
                this.addBookingServiceOnSale(currentBSView);
                if (!currentBSView.giftItemView) {
                    continue;
                }
                let giftItemSale = GiftItemData.getByCode(currentBSView.giftItemView.code);
                let giftItemSaleStatus = giftItemSale && giftItemSale.sale ? giftItemSale.sale.status : null;

                if (giftItemSaleStatus === SaleStatus.SOLD) {
                    if (currentBSView.price !== currentBSView.serviceView.price)
                        currentBSView.setService(currentBSView.serviceView, currentBSView);

                    if (currentBSView.giftItemView.originalPrice > currentBSView.price) {
                        this.currentPayment = currentBSView.price;
                        this.posView.selectors.giftItemToUse.giftItemView = currentBSView.giftItemView;
                        this.posView.edited.saleView = this;
                        this.posView.useSelectedGiftItem();
                        this.calculateSaleFields();
                    } else {
                        if (currentBSView.giftItemView.originalPrice < currentBSView.price)//set discount to match giftitem price
                        {
                            currentBSView.price = currentBSView.giftItemView.originalPrice;
                            currentBSView.discountPercent = Math.round(100 * (100 - 100 * currentBSView.price / currentBSView.originalPrice)) / 100;
                        }

                        this.calculateSaleFields();
                        this.currentPayment = currentBSView.price;
                        this.addPaymentView("GIFT", currentBSView.giftItemView);
                    }
                }
            }
            this.updateLoyaltyCardItem();
        };

        SaleView.prototype.activeEditCustomerMode = function () {
            if (this.customerView == null)
                this.customerView = this.createCustomerFromString(this.customerLabel);
            if (this.bookingView)
                this.bookingView.customerView = this.customerView;

            if (this.posView) {
                this.posView.selectors.giftItemToUse.updateCustGiftItemsToUse(this);
                this.posView.selectors.customerProposedItems.update(this.customerView);
            }
        };

        SaleView.prototype.createEmptyCustomer = function () {
            this.customerView = new CustomerView(null, -1, this.posView ? this.posView.domainView : null);
            if (this.bookingView)
                this.bookingView.customerView = this.customerView;
            this.loyaltyCardItemView = null;
            if (this.posView) {
                this.posView.selectors.giftItemToUse.updateCustGiftItemsToUse(this);
                this.posView.selectors.customerProposedItems.update(this.customerView);
            }
        };

        SaleView.prototype.onCustomerSelect = function (item) {
            //call when customer is selected
            if (!item.isHistoryInit) {
                item.initCustomerHistoryDatas(item.getModel());
            }
            this.customerView = item;
            if (this.bookingView)
                this.bookingView.customerView = this.customerView;
            if (this.posView) {
                this.posView.selectors.giftItemToUse.updateCustGiftItemsToUse(this);
                this.posView.selectors.customerProposedItems.update(this.customerView);
            }
            this.updateLoyaltyCardItem();

            //change view
            this.activeEditCustomerMode();
            this.displayGiftItemMailRecipientError = false;
        };

        SaleView.prototype.updateLoyaltyCardItem = function (isOnLine) {
            if (this.customerView && this.customerView.nbLoyaltyCardItemNotUsed !== 0) {
                this.updateLoyaltyCardItemAction(isOnLine);
                this.calculateSaleFields();
            }
        };

        SaleView.prototype.updateToOccasionalCustomer = function () {
            this.isOccasionalCustomer = true;
            this.displayGiftItemMailRecipientError = false;
            if (this.bookingView) {
                this.bookingView.isOccasionalCustomer = true;
                this.bookingView.customerView = null;
            }
        }

        SaleView.prototype.updateLoyaltyCardItemAction = function (isOnLine) {
            if (this.customerView && this.customerView.nbLoyaltyCardItemNotUsed !== 0) {
                if (!this.loyaltyCardItemView)
                    this.loyaltyCardItemView = new LoyaltyCardItemView(LoyaltyCardItemData.getByIndex(this.customerView.loyaltyCardItemsNotUsedView[0].index), this.customerView.loyaltyCardItemsNotUsedView[0].index, 0, null, this.posView);
                this.loyaltyDate = this.loyaltyCardItemView.getValidityDateFromNow();
                if (isOnLine && this.loyaltyCardItemView.goalType === "special")
                    this.nbLoyaltyCardGoal = -1;// don't apply automatically special discount on website
                this.loyaltyCardItemsView = [];
            }
        };

        SaleView.prototype.closeEditCustomerMode = function () {
            this.customerView = null;
            this.customerLabel = "";
            this.form.editCustomerMode = false;
            this.form.displayCustomerButton = null;
            this.form.displayError = false;
            this.isOccasionalCustomer = false;

            if (this.loyaltyCardItemsView && this.loyaltyCardItemsView.length === 0)
                this.loyaltyCardItemView = null;
            else
                this.loyaltyCardItemView = this.loyaltyCardItemsView[0];
            if (this.posView) {
                this.posView.selectors.giftItemToUse.updateCustGiftItemsToUse(this);
                this.posView.selectors.customerProposedItems.update(this.customerView);
            }
        };

        SaleView.prototype.cancelCustomer = function () {
            if (this.customerView && this.customerView.cIndex !== -1)//Customer exist
            {
                this.customerView.reloadModel();
                this.form.displayCustomerButton = null;
                this.form.displayError = false;
                this.form.displayCustomerButton = null;
            } else {
                this.closeEditCustomerMode();
            }
        };

        SaleView.prototype.createCustomerFromString = function (customerLabel) {
            //CustomerView is a string and must copied to a new customerView.lastName + firstName
            let custView = new CustomerView(null, -1, this.posView ? this.posView.domainView : null);
            let indexSpace = customerLabel.indexOf(' ');
            if (indexSpace !== -1) {
                custView.lastName = customerLabel.substring(0, indexSpace);
                custView.firstName = customerLabel.substring(indexSpace + 1);
            } else
                custView.lastName = customerLabel;
            custView.label = customerLabel;
            return custView;
        };

        //Cures
        SaleView.prototype.getSaleProductViewById = function (id) {
            let bs;
            for (let i = 0; i < this.saleProductsView.length; i++) {
                bs = this.saleProductsView[i].getModel();
                if (bs && bs.id === id)
                    return this.saleProductsView[i];
            }
            return null;
        };

        SaleView.prototype.getSaleCureViewById = function (id) {
            var bs;
            for (var i = 0; i < this.saleCuresView.length; i++) {
                bs = this.saleCuresView[i].getModel();
                if (bs && bs.id === id)
                    return this.saleCuresView[i];
            }
            return null;
        };

        SaleView.prototype.setStatus = function (status) {
            this.isReadOnly = (status == "sold" || status == "canceled" || status == "credit" || status == "soldProcess" || status == "advanceProcess" || status == "advanceKeeped");
            this.status = status;
        };

        SaleView.prototype.isOnlineAccount = function () {
            return (this.status === "advance" && this.isCreatedByCustomer);
        };

        SaleView.prototype.setDelivery = function (delivery, manageProduct, amount) {
            this.delivery = delivery;
            if (manageProduct) {
                var saleProductViewDelivery = null;
                for (var i = this.saleProductsView.length - 1; i >= 0; i--)
                    if (!this.saleProductsView[i].productView && this.saleProductsView[i].label == "Frais de port") {
                        if ((delivery != "address" || this.saleProductsView[i].price < amount)) // change to deliver on site or new deliveryPrice > old price
                            this.removeSaleProductView(this.saleProductsView[i]);
                        else
                            saleProductViewDelivery = this.saleProductsView[i];
                    }
                if (delivery == "address" && !saleProductViewDelivery) {
                    var saleProductView = new SaleProductView(null, -1, 0, this);
                    saleProductView.label = "Frais de port";
                    saleProductView.originalPrice = amount;
                    saleProductView.price = amount;
                    saleProductView.quantity = 1;
                    saleProductView.updatePriceHT();
                    var vatView = this.posView.domainView.getDefaultVatView();
                    if (vatView) {
                        saleProductView.vat = vatView.tax;
                        saleProductView.vatCode = vatView.code;
                    }
                    this.saleProductViewDelivery = saleProductView;
                    this.addSaleProductView(saleProductView, true);
                }
                this.calculateSaleFields();
            }
        };

        SaleView.prototype.addProductOnSale = function (productView, hrView, isOnInternet) {
            let ignoreQuantity = this.isEstimationCost();
            if (productView) {
                for (let i = this.saleProductsView.length - 1; i >= 0; i--) {
                    if (this.saleProductsView[i].productView === productView) {
                        this.saleProductsView[i].quantityInput++;
                        this.saleProductsView[i].onChangeQuantity();
                        return;
                    }
                }

                let spView = new SaleProductView(null, -1, this.saleProductsView.length, this);
                spView.setProduct(productView, isOnInternet, ignoreQuantity);//set activity end using service duration
                spView.hrView = hrView;
                this.addSaleProductView(spView, true);//add bs to sale view

                //Set selection
                productView.isSelected = true;

                //close on mobile
                if (this.posView && this.posView.domainView && this.posView.domainView.pTView && this.posView.domainView.pTView.dim.mobileFormat)
                    this.posView.selectors.product.display = false;
                if (this.posView && this.posView.resizeBasket)//on webSite the posView is not a real PosView object (see WebSiteGiftItemCtrl.js in the addGiftItem function)
                    this.posView.resizeBasket();
            }
        };

        SaleView.prototype.addCureOnSale = function (cureView, hrView, isOnInternet) {

            if (cureView) {
                var scView = new SaleCureView(null, -1, 0, this);
                scView.setCure(cureView, isOnInternet);
                scView.hrView = hrView;
                this.addSaleCureView(scView, true);//add scView to sale view

                //Set selection
                cureView.isSelected = true;

                //close on mobile
                if (this.posView && this.posView.domainView && this.posView.domainView.pTView && this.posView.domainView.pTView.dim.mobileFormat)
                    this.posView.selectors.cure.display = false;
                if (this.posView && this.posView.resizeBasket)//on webSite the posView is not a real PosView object (see WebSiteGiftItemCtrl.js in the addGiftItem function)
                    this.posView.resizeBasket();
            }
        };

        SaleView.prototype.addLoyaltyCardOnSale = function (loyaltyCardView, hrView, isOnInternet) {

            if (loyaltyCardView) {
                var lciView = new LoyaltyCardItemView(null, -1, 0, this);
                lciView.setLoyaltyCard(loyaltyCardView, isOnInternet);
                lciView.hrView = hrView;
                this.addLoyaltyCardItemView(lciView, true);//add lciView to sale view

                //Set selection
                loyaltyCardView.isSelected = true;

                //close on mobile
                if (this.posView && this.posView.domainView && this.posView.domainView.pTView && this.posView.domainView.pTView.dim.mobileFormat)
                    this.posView.selectors.loyaltyCard.display = false;
                if (this.posView && this.posView.resizeBasket)//on webSite the posView is not a real PosView object (see WebSiteGiftItemCtrl.js in the addGiftItem function)
                    this.posView.resizeBasket();
            }
        };

        SaleView.prototype.addGiftItemView = function (giView, updateSaleFields) {
            var index = this.giftItemsView.indexOf(giView);
            if (index == -1) {
                this.giftItemsView.push(giView);
                this.hasGiftItems = true;
                giView.saleView = this;
                if (updateSaleFields) {
                    this.remvoveLoyaltyGoal();
                    this.calculateSaleFields();
                    this.resetPayments();
                    this.updateBillPosition();
                }
                if (this.posView && this.posView.resizeBasket)//on webSite the posView is not a real PosView object (see WebSiteGiftItemCtrl.js in the addGiftItem function)
                    this.posView.resizeBasket();
            }

        };

        SaleView.prototype.addLoyaltyCardItemView = function (lcView, updateSaleFields) {
            var index = this.loyaltyCardItemsView.indexOf(lcView);
            if (index == -1) {
                this.loyaltyCardItemsView.push(lcView);
                lcView.saleView = this;
                this.loyaltyCardItemView = lcView;//assign it as used Loyalty card
                this.loyaltyDate = this.loyaltyCardItemView.getValidityDateFromNow();
                if (updateSaleFields) {
                    this.calculateSaleFields();
                    this.resetPayments();
                    this.updateBillPosition();
                }
            }
        };

        SaleView.prototype.createAndAddGiftItemView = function (serviceView, price, editionType, hrView, validityDate, customerView, isFromUsage) {
            var giftItemView = new GiftItemView(null, -1, this.saleProductsView.length + this.saleCuresView.length + this.giftItemsView.length + 1, this);
            giftItemView.price = price;
            giftItemView.originalPrice = price;
            giftItemView.originalPriceInput = $filter('currencyFormatFilter')(giftItemView.originalPrice);
            giftItemView.serviceView = serviceView;
            giftItemView.updatePriceHT();
            giftItemView.hrView = hrView;
            giftItemView.validityDate = validityDate;
            giftItemView.editionType = editionType;
            giftItemView.customerView = customerView;
            giftItemView.updateModel(true);
            this.giftItemsView.push(giftItemView);
            this.hasGiftItems = true;
            this.remvoveLoyaltyGoal();
            this.discountPercent = 0;
            this.calculateSaleFields();
            if (!isFromUsage)
                this.resetPayments();
            this.posView.resetGiftItemSelector();
            return giftItemView;
        };

        SaleView.prototype.addSaleProductView = function (bpView, updateSaleFields) {
            var index = this.saleProductsView.indexOf(bpView);
            if (index === -1) {
                this.saleProductsView.push(bpView);
                bpView.saleView = this;
                bpView.billPosition = this.saleProductsView.length;
                if (updateSaleFields) {
                    this.updateBillPosition();
                    this.calculateSaleFields();
                    this.resetPayments();
                }
            }
        };

        SaleView.prototype.addSaleCureView = function (bsView, updateSaleFields) {
            var index = this.saleCuresView.indexOf(bsView);
            if (index == -1) {
                this.saleCuresView.push(bsView);
                bsView.saleView = this;
                if (updateSaleFields) {
                    this.updateBillPosition();
                    this.calculateSaleFields();
                    this.resetPayments();
                }

            }

        };

        SaleView.prototype.removeProductOnSale = function (productView) {
            for (var i = this.saleProductsView.length - 1; i >= 0; i--)
                if (this.saleProductsView[i].productView === productView) {
                    this.saleProductsView[i].quantityInput--;
                    this.saleProductsView[i].onChangeQuantity();
                    if (this.saleProductsView[i].quantity == 0)
                        this.removeSaleProductView(this.saleProductsView[i]);
                    else
                        this.calculateSaleFields();
                    return;
                }
        };

        SaleView.prototype.removeCureOnSale = function (cureView) {

            for (var i = this.saleCuresView.length - 1; i >= 0; i--)
                if (this.saleCuresView[i].cureView === cureView) {
                    this.saleCuresView[i].quantityInput--;
                    this.saleCuresView[i].onChangeQuantity();
                    if (this.saleCuresView[i].quantity == 0)
                        this.removeSaleCureView(this.saleCuresView[i]);
                    else
                        this.calculateSaleFields();
                    return;
                }
        };

        SaleView.prototype.removeSaleProductViewAndManageQuantity = function (bsView) {
            bsView.quantityInput = 0;
            bsView.onChangeQuantity();
            this.resetDiscountPercentForEmptySale();
            this.removeSaleProductView(bsView);
            this.posView.domainView.scope.generateAuditTrail(NfConstant.CODE_323.value);
        };

        SaleView.prototype.removeSaleCureViewAndManageQuantity = function (bsView) {
            bsView.quantityInput = 0;
            bsView.onChangeQuantity();
            this.resetDiscountPercentForEmptySale();
            this.removeSaleCureView(bsView);
            this.posView.domainView.scope.generateAuditTrail(NfConstant.CODE_323.value);
        };

        SaleView.prototype.removeSaleProductView = function (bsView) {
            var index = this.saleProductsView.indexOf(bsView);
            if (index === -1)
                return;   //TODO raise error
            this.saleProductsView.splice(index, 1);
            if (bsView.productView)
                bsView.productView.isSelected = false;
            this.resetPayments();
            this.updateBillPosition();

        };

        SaleView.prototype.removeSaleCureView = function (scView) {
            var index = this.saleCuresView.indexOf(scView);
            if (index == -1)
                return;   //TODO raise error
            this.saleCuresView.splice(index, 1);
            if (scView.cureView)
                scView.cureView.isSelected = false;
            this.resetPayments();
            this.updateBillPosition();

        };

        SaleView.prototype.selectServices = function () {
            if (this.bookingView)
                this.bookingView.selectServices();
            for (var i = 0; i < this.saleServicesView.length; i++)
                this.saleServicesView[i].selectService();
        };

        SaleView.prototype.selectProducts = function () {
            for (var i = 0; i < this.saleProductsView.length; i++)
                this.saleProductsView[i].selectProduct();
        };

        SaleView.prototype.selectCures = function () {
            for (var i = 0; i < this.saleCuresView.length; i++)
                this.saleCuresView[i].selectCure();
        };

        SaleView.prototype.updateBillPosition = function () {
            var billPosition = 1;
            for (var i = 0; i < this.saleProductsView.length; i++)
                this.saleProductsView[i].billPosition = billPosition++;
            for (var i = 0; i < this.saleCuresView.length; i++)
                this.saleCuresView[i].billPosition = billPosition++;
            for (var i = 0; i < this.giftItemsView.length; i++)
                this.giftItemsView[i].billPosition = billPosition++;
            for (var i = 0; i < this.loyaltyCardItemsView.length; i++)
                this.loyaltyCardItemsView[i].billPosition = billPosition++;
        };

        SaleView.prototype.hasProduct = function (productView) {
            for (var i = 0; i < this.saleProductsView.length; i++)
                if (this.saleProductsView[i].productView === productView)
                    return true;
            return false;
        };

        SaleView.prototype.hasProductNotNull = function () {
            for (var i = 0; i < this.saleProductsView.length; i++)
                if (this.saleProductsView[i].productView)
                    return true;
            return false;
        };

        SaleView.prototype.hasGiftItemEditionType = function (editionType) {
            for (var i = 0; i < this.giftItemsView.length; i++)
                if (this.giftItemsView[i].editionType === editionType)
                    return true;
            return false;
        };

        SaleView.prototype.hasCure = function (cureView) {
            for (var i = 0; i < this.saleCuresView.length; i++)
                if (this.saleCuresView[i].cureView === cureView)
                    return true;
            return false;
        };

        SaleView.prototype.removeGiftItemView = function (giView) {
            var index = this.giftItemsView.indexOf(giView);
            if (index === -1)
                return;   //TODO raise error
            this.giftItemsView.splice(index, 1);
            this.resetPayments();
            this.resetDiscountPercentForEmptySale();
            this.nbLoyaltyCardGoal = 0;
            if (this.giftItemsView.length === 0) {
                this.hasGiftItems = false;
            }
            this.calculateSaleFields();
            this.posView.domainView.scope.generateAuditTrail(NfConstant.CODE_323.value);
        };

        SaleView.prototype.removeLoyaltyCardItemView = function (lciView) {
            var index = this.loyaltyCardItemsView.indexOf(lciView);
            if (index === -1)
                return;   //TODO raise error
            this.loyaltyCardItemsView.splice(index, 1);
            if (lciView.loyaltyCardView)
                lciView.loyaltyCardView.isSelected = false;
            this.resetPayments();
            if (this.loyaltyCardItemsView.length == 0) {
                this.loyaltyCardItemView = null;
                this.nbLoyaltyCardGoal = 0;
            } else
                this.loyaltyCardItemView = this.loyaltyCardItemsView[0];
            this.calculateSaleFields(null, true);
            this.calculateEarnedLoyaltyPts();
            this.posView.domainView.scope.generateAuditTrail(NfConstant.CODE_323.value);
        };

        //Services
        SaleView.prototype.getSaleServiceViewById = function (id) {
            var bs;
            for (var i = 0; i < this.saleServicesView.length; i++) {
                bs = this.saleServicesView[i].getModel();
                if (bs && bs.id == id)
                    return this.saleServicesView[i];
            }
            return null;
        };

        SaleView.prototype.getGiftItemViewById = function (id) {
            var bs;
            for (var i = 0; i < this.giftItemsView.length; i++) {
                bs = this.giftItemsView[i].getModel();
                if (bs && bs.id == id)
                    return this.giftItemsView[i];
            }
            return null;
        };

        SaleView.prototype.getGiftItemViewByIdOnPayments = function (id) {
            var bs;
            for (var i = 0; i < this.paymentsView.length; i++)
                if (this.paymentsView[i].giftItemView) {
                    bs = GiftItemData.getByIndex(this.paymentsView[i].giftItemView.giIndex);
                    if (bs && bs.id == id)
                        return this.paymentsView[i].giftItemView;
                }
            return null;
        };

        SaleView.prototype.addServiceOnSale = function (serviceView, hrView) {
            if (!this.posView.domainView.scope.isReadOnly() && serviceView && hrView) {
                if (this.bookingView && (this.status == 'created' || this.status == 'waiting' || this.status == 'advance'))// created from bookingView
                {
                    this.bookingView.setSelectedByUserHrView(hrView);
                    this.bookingView.addServiceOnBookingOnUserSelect(serviceView);
                } else {
                    var ssView = new SaleServiceView(null, -1, this.saleServicesView.length, this);
                    ssView.setService(serviceView);//set activity end using service duration

                    if (ssView.subSaleServicesView.length == 0) {
                        ssView.hrView = hrView;
                    } else {

                        var hrHasSubservices = false;
                        var hrHasAllSubservices = true;

                        var subServicesWithHR = $filter('filter')(ssView.subSaleServicesView, function (subSaleSV, index, array) {
                            return subSaleSV.serviceView.nbHrsNeeded;
                        });

                        var hr = hrView.getModel();

                        //general traitement : subservice are assigned to the HR selected ih the HR have the skill
                        //otherwhise the subservice is assigned to the first HR which have the skill
                        for (var i = 0; i < subServicesWithHR.length; i++) {
                            if (hr.hasService(subServicesWithHR[i].serviceView.getModel())) {
                                hrHasSubservices = true;
                                subServicesWithHR[i].hrView = hrView;
                            } else {
                                if (subServicesWithHR[i].serviceView.nbHrsNeeded) {
                                    hrHasAllSubservices = false;
                                    var hrs = HumanResourceData.getActiveList();
                                    var filterdHistory = $filter('filter')(hrs, function (hr, index, array) {
                                        return (hr.hasService(subServicesWithHR[i].serviceView.getModel()));
                                    });
                                    if (filterdHistory.length != 0) {
                                        subServicesWithHR[i].hrView = this.posView.domainView.getHrView(filterdHistory[0]);
                                    }
                                }
                            }
                        }

                        if (!hrHasSubservices) {//HR has the skill for no subservice
                            for (var i = 0; i < subServicesWithHR.length; i++) {
                                subServicesWithHR[i].hrView = hrView;
                            }
                        }

                        if (!hrHasSubservices || hrHasAllSubservices) {
                            ssView.uniqueSubSaleServiceHr = hr;
                            ssView.isSubSaleServicesViewHidden = true;
                        } else {
                            ssView.uniqueSubSaleServiceHr = null;
                            ssView.isSubSaleServicesViewHidden = false;
                        }
                    }

                    this.addSaleServiceView(ssView, true);//add bs to sale view

                    //Set selection
                    serviceView.isSelected = true;

                    //close on mobile
                    if (this.posView && this.posView.domainView.pTView.dim.mobileFormat)
                        this.posView.selectors.service.display = false;
                }
                if (this.posView && this.posView.resizeBasket)//on webSite the posView is not a real PosView object (see WebSiteGiftItemCtrl.js in the addGiftItem function)
                    this.posView.resizeBasket();
            }
        };

        SaleView.prototype.addSaleServiceView = function (ssView, updateSaleFields) {
            let index = this.saleServicesView.indexOf(ssView);
            if (index === -1) {
                this.saleServicesView.push(ssView);
                ssView.saleView = this;
                ssView.billPosition = this.saleServicesView.length;
                if (updateSaleFields) {
                    this.calculateSaleFields();
                    this.resetPayments();
                }
            }

        };

        SaleView.prototype.addBookingServiceOnSale = function (bsView) {
            let ssView = null;
            if (bsView) {
                ssView = new SaleServiceView(null, -1, this.saleServicesView.length, this);
                ssView.loadBookingServiceView(bsView);

                let sumSubServicesPrice = 0;

                for (let j = 0; j < bsView.subBsView.length; j++) {
                    let sssView = new SaleServiceView(null, -1, String.fromCharCode(97 + j), null, ssView);
                    sssView.loadBookingServiceView(bsView.subBsView[j]);
                    ssView.addSubSaleServiceView(sssView);

                    sumSubServicesPrice += sssView.price;
                    //now the discount percent must be well initialised
                    //ssView.updateDiscountPercentSubServices();
                    //ssView.updatePrice();
                }
                this.addSaleServiceView(ssView, false);//add bs to sale view
            }
            return ssView;
        };

        SaleView.prototype.removeServiceOnSale = function (serviceView) {

            for (let i = this.saleServicesView.length - 1; i >= 0; i--)
                if (this.saleServicesView[i].serviceView === serviceView) {
                    this.saleServicesView[i].quantityInput--;
                    this.saleServicesView[i].onChangeQuantity();
                    if (this.saleServicesView[i].quantity === 0)
                        this.removeSaleServiceView(this.saleServicesView[i]);
                    else
                        this.calculateSaleFields();
                    return;
                }
        };

        SaleView.prototype.removeSaleServiceView = function (bsView) {
            let index = this.saleServicesView.indexOf(bsView);
            if (index === -1)
                return;   //TODO raise error
            this.posView.domainView.scope.generateAuditTrail(NfConstant.CODE_323.value);
            this.saleServicesView.splice(index, 1);
            if (bsView.serviceView)
                bsView.serviceView.isSelected = false;
            this.resetPayments();
            this.resetDiscountPercentForEmptySale();
            this.calculateSaleFields();
        };

        SaleView.prototype.hasService = function (serviceView) {
            for (let i = 0; i < this.saleServicesView.length; i++)
                if (this.saleServicesView[i].serviceView === serviceView)
                    return true;
            return false;
        };

        SaleView.prototype.resetDiscountPercentForEmptySale = function () {
            if (this.saleServicesView.length === 0 && this.saleProductsView.length === 0 && this.saleCuresView.length === 0 && this.giftItemsView.length === 0 && this.loyaltyCardItemsView.length === 0 && this.loyaltyDiscount > 0)
                this.discountPercent = 0;
        }

        SaleView.prototype.calculateSaleFields = function (ignoreUpdatePriceInput, loyaltyCardDeleted) {
            this.servicesPrice = 0;
            this.productsPrice = 0;
            this.curesPrice = 0;
            this.giftItemsPrice = 0;
            this.loyaltyCardsPrice = 0;
            this.loyaltyDiscount = 0;
            let discountValue = 0;

            let discountPercent = this.discountPercent;
            if (this.discountPercent && typeof this.discountPercent === 'string') {
                discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
                discountPercent = parseFloat(discountPercent);
            }

            if (this.bookingView && (this.status === "created" || this.status === "waiting" || this.status === "advance" || this.status === "soldProcess" || this.status === "advanceProcess"))
                for (let i = 0; i < this.bookingView.bookingServicesView.length; i++)
                    this.servicesPrice += this.bookingView.bookingServicesView[i].price;
            else
                for (let i = 0; i < this.saleServicesView.length; i++)
                    this.servicesPrice += this.saleServicesView[i].price;
            for (let i = 0; i < this.saleProductsView.length; i++)
                this.productsPrice += this.saleProductsView[i].price;
            for (let i = 0; i < this.saleCuresView.length; i++)
                this.curesPrice += this.saleCuresView[i].price;
            for (let i = 0; i < this.giftItemsView.length; i++)
                this.giftItemsPrice += this.giftItemsView[i].price;
            for (let i = 0; i < this.loyaltyCardItemsView.length; i++)
                this.loyaltyCardsPrice += this.loyaltyCardItemsView[i].price;

            let allItemsPrice = this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice;
            if (this.loyaltyCardItemView && !loyaltyCardDeleted && this.checkSalePartnerSettings(SaleSettings.UPDATE_DISCOUNT)) {
                if (this.nbLoyaltyCardGoal > 0 && this.loyaltyCardItemView.goalType !== "special") {
                    discountPercent = 0;//drived by loyalty
                    discountValue = 0;

                }
                this.calculateUsedLoyaltyPts(allItemsPrice);
                this.hasLoyaltyDiscount = false;
                if (this.nbLoyaltyCardGoal > 0)//goal reached : apply discount
                {
                    this.loyaltyDiscount += this.loyaltyCardItemView.computeLoyaltyDiscount(this.loyaltyPts);
                    this.hasLoyaltyDiscount = (this.loyaltyDiscount > 0);
                    if (this.loyaltyCardItemView.goalType === "discountValue") {
                        discountValue += this.loyaltyDiscount;
                    }
                    if (this.loyaltyCardItemView.goalType === "discountPercent" && this.loyaltyCardsPrice === 0) {//Can apply if discount is loyaltyCardsPrice has price
                        discountPercent += this.loyaltyDiscount;
                    }
                }
            } else if (loyaltyCardDeleted) {
                discountValue = 0;
                discountPercent = 0;
                this.discountPercent = 0;
            }

            if (discountPercent && discountPercent !== 0)
                discountValue += (discountPercent * allItemsPrice / 100);
            this.price = Math.round(((allItemsPrice) - discountValue) * 100) / 100;
            if (ignoreUpdatePriceInput == undefined || !ignoreUpdatePriceInput)
                this.priceInput = $filter('currencyFormatFilter')(this.price);
            if (this.loyaltyCardItemView)
                this.updatePercent();
            this.productsPriceWithD = Math.round((this.productsPrice - this.productsPrice * this.discountPercent / 100) * 100) / 100;
            this.curesPriceWithD = Math.round((this.curesPrice - this.curesPrice * this.discountPercent / 100) * 100) / 100;
            this.servicesPriceWithD = Math.round((this.servicesPrice - this.servicesPrice * this.discountPercent / 100) * 100) / 100;
            this.giftItemsPriceWithD = Math.round((this.giftItemsPrice - this.giftItemsPrice * this.discountPercent / 100) * 100) / 100;
            this.loyaltyCardsPriceWithD = Math.round((this.loyaltyCardsPrice - this.loyaltyCardsPrice * this.discountPercent / 100) * 100) / 100;

            this.payedPrice = 0;
            for (var i = 0; i < this.paymentsView.length; i++)
                this.payedPrice += this.paymentsView[i].price;

            this.currentPayment = this.price - this.payedPrice;

            if (this.status === SaleStatus.ADVANCE && this.currentPayment >= 0) {
                this.form.displayErrorCurrentPayment = false;
            }

            this.currentPaymentInput = $filter('currencyFormatFilter')(this.currentPayment);
            this.calculateVatLines();
            this.updateSellerFromItems();
            this.calculateEarnedLoyaltyPts();
            this.checkForInvalidAmounts();
        };

        SaleView.prototype.calculateEarnedLoyaltyPts = function () {
            if (this.status === "created" || this.status === "waiting" || this.status === "advance") {
                this.loyaltyPts = 0;
                if (this.loyaltyCardItemView) {
                    var loyaltyBasedPrice = this.price - this.loyaltyCardsPriceWithD;
                    if (this.paymentsView.length != 0) {
                        var giftPrice = 0;
                        for (var i = 0; i < this.paymentsView.length; i++)
                            if (this.paymentsView[i].type === "GIFT")
                                giftPrice += this.paymentsView[i].price;
                        loyaltyBasedPrice -= giftPrice;
                    }
                    this.loyaltyPts = Math.round((this.loyaltyCardItemView.ptsByCa * loyaltyBasedPrice + this.loyaltyCardItemView.ptsBySale));
                }
            }
        };

        SaleView.prototype.calculateUsedLoyaltyPts = function (allItemsPrice) {
            if (this.status === "created" || this.status === "waiting" || this.status === "advance") {
                this.loyaltyPts = 0;
                this.loyaltyUsedPts = 0;
                if (this.loyaltyCardItemView && this.nbLoyaltyCardGoal !== -1) {
                    let hasLoyaltyCardInShoppingCart = this.loyaltyCardItemsView.length > 0;
                    this.nbLoyaltyCardGoal = this.loyaltyCardItemView.nbLoyaltyCardGoal(allItemsPrice, null, hasLoyaltyCardInShoppingCart);
                }
                if (this.loyaltyCardItemView && this.nbLoyaltyCardGoal === 1) {//-> Not goal reached : generate points
                    this.loyaltyPts = -this.loyaltyCardItemView.getGoalPoints(allItemsPrice);//goal reached -> generate negative points
                    this.loyaltyUsedPts = this.loyaltyPts;
                }
            }
        };

        SaleView.prototype.remvoveLoyaltyGoal = function () {
            this.nbLoyaltyCardGoal = -1;
            this.hasLoyaltyDiscount = false;
            if (this.loyaltyCardItemView && this.loyaltyCardItemView.goalType != "special")
                this.discountPercent = 0;
            this.calculateSaleFields();
        };

        SaleView.prototype.calculateVatLines = function () {
            this.vatLines = this.initVatLines();
            var defaultVat = null;

            if (this.posView && this.posView.domainView)
                defaultVat = this.posView.domainView.getDefaultVatTax();

            if (defaultVat != null) //Can be 0
            {
                var priceWithD;
                if ((this.status == "created" || this.status == "waiting" || this.status == "advance") && this.bookingView)
                    for (var i = 0; i < this.bookingView.bookingServicesView.length; i++) {
                        priceWithD = this.bookingView.bookingServicesView[i].price - this.bookingView.bookingServicesView[i].price * this.discountPercent / 100;
                        this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                    }
                else
                    for (var i = 0; i < this.saleServicesView.length; i++) {
                        priceWithD = this.saleServicesView[i].price - this.saleServicesView[i].price * this.discountPercent / 100;
                        this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                    }
                for (var i = 0; i < this.saleCuresView.length; i++) {
                    priceWithD = this.saleCuresView[i].price - this.saleCuresView[i].price * this.discountPercent / 100;
                    this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                }
                for (var i = 0; i < this.loyaltyCardItemsView.length; i++) {
                    priceWithD = this.loyaltyCardItemsView[i].price - this.loyaltyCardItemsView[i].price * this.discountPercent / 100;
                    this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                }
                //not vat gor gifitem
                // Product can have a specific VAT
                for (var i = 0; i < this.saleProductsView.length; i++) {
                    priceWithD = this.saleProductsView[i].price - this.saleProductsView[i].price * this.discountPercent / 100;
                    if (this.saleProductsView[i].vat == null)
                        this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                    else
                        this.addVatAmount(this.saleProductsView[i].vat, priceWithD - priceWithD * 100 / (100 + this.saleProductsView[i].vat), priceWithD * 100 / (100 + this.saleProductsView[i].vat));
                }
            }

            let totalVat = 0;
            let maxAmount = 0;
            // calculate total vat and set Sale.vat to max amount or maxItemConcerned by vat type

            for (let i = 0; i < this.vatLines.length; i++) {
                this.vatLines[i].amount = Math.round(this.vatLines[i].amount * 100) / 100;
                totalVat += this.vatLines[i].amount;
                if (this.vatLines[i].amount >= maxAmount) {
                    maxAmount = this.vatLines[i].amount;
                    this.vat = this.vatLines[i].tax;
                    this.vatCode = this.vatLines[i].code;
                }
            }
            //when the total VAT is 0 we choose the VAT line that has the largest amount HT
            if (totalVat === 0) {
                let maxHt = 0;
                for (let i = 0; i < this.vatLines.length; i++) {
                    this.vatLines[i].amount = Math.round(this.vatLines[i].amount * 100) / 100;
                    if (this.vatLines[i].ht >= maxHt) {
                        maxHt = this.vatLines[i].ht;
                        this.vat = this.vatLines[i].tax;
                        this.vatCode = this.vatLines[i].code;
                    }
                }
            }
            this.priceHT = this.price - totalVat;
        };

        SaleView.prototype.initVatLines = function () {
            var vatTaxes = [];

            if (this.posView && this.posView.domainView) {
                var vatsView = this.posView.domainView.getVatsView();
                if (vatsView)
                    for (var i = 0; i < vatsView.length; i++)
                        if (vatsView[i].isUsable)
                            vatTaxes.push({tax: vatsView[i].tax, code: vatsView[i].code, amount: 0, ht: 0});
            }
            return vatTaxes;
        };

        SaleView.prototype.addVatAmount = function (tax, amount, ht) {
            var vatLine = null;
            for (var i = 0; i < this.vatLines.length; i++)
                if (this.vatLines[i].tax == tax)
                    vatLine = this.vatLines[i];
            if (!vatLine)
                this.vatLines.push({tax: tax, amount: amount, ht: ht});
            else {
                vatLine.amount += amount;
                vatLine.ht += ht;
            }
        };

        SaleView.prototype.validateCustomer = function (save) {
            if (this.customerView) {
                if (!this.customerView.canSave())
                    this.form.displayError = true;
                else {
                    if (!this.customerView.getModel() && this.posView && this.posView.domainView)//Add to view
                        this.posView.domainView.addCustomerView(this.customerView);
                    this.customerView.updateModel(save);
                    this.form.displayError = false;
                    this.form.displayCustomerButton = null;
                }
                this.displayGiftItemMailRecipientError = false;
            }
        }

        SaleView.prototype.initModel = function () {
            let sale = null;
            this.validateCustomer(false);

            if (this.saleIndex === -1) // creation
            {
                let day = null;
                if (this.dayView)
                    day = this.dayView.getModel();

                sale = new Sale(null, day, null, null, false);
                this.saleIndex = SaleData.getIndexOf(sale);
                if (day)
                    day.addSale(sale);

                sale.status = this.status;//must be done before giftitem update
                for (let i = 0; i < this.saleServicesView.length; i++)
                    this.saleServicesView[i].updateModel();
                for (let i = 0; i < this.saleProductsView.length; i++)
                    this.saleProductsView[i].updateModel();
                for (let i = 0; i < this.saleCuresView.length; i++)
                    this.saleCuresView[i].updateModel();
                for (let i = 0; i < this.giftItemsView.length; i++)
                    this.giftItemsView[i].updateModel();
                for (let i = 0; i < this.loyaltyCardItemsView.length; i++)
                    this.loyaltyCardItemsView[i].updateModel();
                //must be done after cure update

                this.copyDataTo(sale, null);
            } else {
                sale = this.getModel();
                if (this.dayView) {
                    let newDay = this.dayView.getModel();
                    if (newDay !== sale.day) {
                        sale.day.removeSale(sale);
                        newDay.addSale(sale);
                    }
                }
                let previousStatus = sale.status;
                sale.status = this.status;//must be done before giftitem update

                sale.saleServices = [];
                for (let i = 0; i < this.saleServicesView.length; i++)
                    this.saleServicesView[i].updateModel();

                sale.saleProducts = [];
                for (let i = 0; i < this.saleProductsView.length; i++)
                    this.saleProductsView[i].updateModel(previousStatus);

                sale.saleCures = [];
                for (let i = 0; i < this.saleCuresView.length; i++)
                    this.saleCuresView[i].updateModel();

                sale.giftItems = [];
                for (let i = 0; i < this.giftItemsView.length; i++)
                    this.giftItemsView[i].updateModel();

                sale.loyaltyCardItems = [];
                for (let i = 0; i < this.loyaltyCardItemsView.length; i++)
                    this.loyaltyCardItemsView[i].updateModel();

                //must be done after cure update
                this.copyDataTo(sale, previousStatus);
            }

            return sale;
        };

        SaleView.prototype.updateModel = function (transaction, endFunction, errorFunction) {
            var saleTransaction = null;
            if (transaction === undefined || !transaction)
                saleTransaction = new Transaction();
            else
                saleTransaction = transaction;

            var sale = this.initModel();

            saleTransaction.addObject(sale);
            var saleView = this;
            if (transaction === undefined || !transaction)//if yes transaction had been created by "this". Then execute it
                SaleSrv.executeTransaction(saleTransaction, function (data) {
                    saleView.saleNumber = sale.saleNumber;
                    saleView.advanceNumber = sale.advanceNumber;
                    saleView.advancePrice = sale.advancePrice;
                    saleView.estimationNumber = sale.estimationNumber;
                    saleView.signatureCode = sale.signatureCode;
                    saleView.softV = sale.softV;
                    saleView.site = sale.site;
                    saleView.totalLoyaltyPts = sale.totalLoyaltyPts;
                    saleView.hasLoyaltyDiscount = sale.hasLoyaltyDiscount;

                    if (endFunction !== undefined)
                        endFunction(data);
                }, errorFunction);

            if (this.form)
                this.form.displayChangeMsg = false;
            return true;

        };

        SaleView.prototype.reloadModel = function () {
            var sale = this.getModel();
            if (sale) {
                if (this.customerView)
                    this.customerView.reloadModel();
                if (this.dayView) // Sale has been changed of day put it again inside day
                {
                    if (this.dayView.getModel() !== sale.day) {
                        /*                  //TODO
                    var dayView = this.pTView.getPlanningDayViewById(sale.day.id);
                    if (!dayView)
                        return;
                    this.dayView.removeSaleView(this);
                    plgDayView.addSaleView(this);
*/
                    }
                } else if (sale.day) {
                    /*
                    var plgDayView = this.pTView.getPlanningDayViewById(sale.day.id);
                    if (!plgDayView)
                        return;
                    plgDayView.addSaleView(this);
*/
                }

                this.loadDataFrom(sale); //reset

            }
            if (this.form)
                this.form.displayChangeMsg = false;

        };

        SaleView.prototype.remove = function (successFunction, errorFunction) {
            var saleView = this;
            if (saleView.status === "advanceProcess") {
                if (!saleView.timeCreated)
                    return;
                let nowTime = new Date().getTime();
                let deleteTime = saleView.timeCreated.getTime() + (1000 * 60 * 60);//1 hour
                if (saleView.timeCreated && nowTime < deleteTime) {
                    let deleleDate = new Date(deleteTime);
                    let opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/infoDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                var tableModel = [];
                                tableModel["label"] = gettextCatalog.getString("Vous ne pouvez pas supprimer ce ticket pour le moment. Traitement en cours jusqu'à");
                                +" " + $filter('date')(deleleDate, "H'h'mm");
                                return tableModel;
                            }
                        }
                    };

                    $dialog.dialog(opts).open();
                    return;
                }
            }
            let opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function () {
                        let tableModel = [];
                        if (saleView.isEstimationCost()) {
                            if (saleView.customerView)
                                tableModel["label"] = " " + gettextCatalog.getString("le devis pour") + " " + saleView.customerView.label;
                            else
                                tableModel["label"] = " " + gettextCatalog.getString("le devis en cours");
                        } else {
                            if (saleView.customerView)
                                tableModel["label"] = " " + gettextCatalog.getString("le ticket pour") + " " + saleView.customerView.label;
                            else
                                tableModel["label"] = " " + gettextCatalog.getString("le ticket en cours");
                        }
                        return tableModel;
                    }
                }
            };

            let d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    saleView.removeModel(undefined, successFunction, errorFunction);
                }
            });
        };

        SaleView.prototype.removeModel = function (transaction, successFunction, errorFunction) {
            if (this.bookingView)
                this.bookingView.saleView = null;
            var sale = this.getModel();
            if (sale) {
                sale.isDeleted = true;
                if (sale.customer)
                    sale.customer.removeSale(sale);
                if (this.customerView)
                    this.customerView.initHistoryView();
                if (sale.day)
                    sale.day.removeSale(sale);
                if (sale.booking)
                    sale.booking.sale = null;
                for (var i = 0; i < sale.payments.length; i++)
                    if (sale.payments[i].giftItem)//gift item is no more used
                    {
                        sale.payments[i].giftItem.isUsed = false;
                        sale.payments[i].giftItem.paymentSale = null;
                    }
                if (transaction !== undefined && transaction) {
                    transaction.addObject(sale);
                } else {
                    SaleSrv.remove(sale, successFunction, errorFunction);
                }
            }
            for (let i = 0; i < this.saleProductsView.length; i++) {
                if (this.saleProductsView[i].productView && this.saleProductsView[i].productView.hasQuantity && !this.isEstimationCost()) {
                    this.saleProductsView[i].productView.quantity += this.saleProductsView[i].quantity;
                    this.saleProductsView[i].removeModel();
                }
            }
            for (var i = 0; i < this.paymentsView.length; i++)
                if (this.paymentsView[i].giftItemView)//gift item is no more used
                {
                    this.paymentsView[i].giftItemView.isUsed = false;
                    this.paymentsView[i].giftItemView.paymentSaleView = null;
                }


        };

        SaleView.prototype.getFirstHrView = function () {

            var hrView = null;
            if ((this.status == "created" || this.status == "waiting" || this.status == "advance") && this.bookingView)
                for (var i = 0; i < this.bookingView.bookingServicesView.length && !hrView; i++) {
                    if (this.bookingView.bookingServicesView[i].plgDayHrView)
                        hrView = this.bookingView.bookingServicesView[i].plgDayHrView.hrView;
                }
            else
                for (var i = 0; i < this.saleServicesView.length && !hrView; i++)
                    hrView = this.saleServicesView[i].hrView;
            for (var i = 0; i < this.saleProductsView.length && !hrView; i++)
                hrView = this.saleProductsView[i].hrView;
            for (var i = 0; i < this.saleCuresView.length && !hrView; i++)
                hrView = this.saleCuresView[i].hrView;
            for (var i = 0; i < this.giftItemsView.length && !hrView; i++)
                hrView = this.giftItemsView[i].hrView;
            for (var i = 0; i < this.loyaltyCardItemsView.length && !hrView; i++)
                hrView = this.loyaltyCardItemsView[i].hrView;

            return hrView;

        };

        SaleView.prototype.updateCurrentPaymentInputArrow = function (number) {
            if (this.currentPaymentInput != null && typeof this.currentPaymentInput === 'string') {
                var priceStr = CurrencyManager.getPriceFromPriceInput(this.currentPaymentInput);
                var price = parseFloat(priceStr);
                if (price !== "NaN") {
                    price += number;
                    this.currentPayment = price;
                    this.currentPaymentInput = $filter('currencyFormatFilter')(price);
                }
            }
        };

        SaleView.prototype.increaseDiscountPercent = function (step) {
            if (!this.isReadOnly && !this.hasGiftItems && this.checkSalePartnerSettings(SaleSettings.UPDATE_DISCOUNT)) {
                if ((step + this.discountPercent) > 100)
                    this.discountPercent = 100;
                else
                    this.discountPercent += step;
                this.resetPayments();
                this.calculateSaleFields();
            }
        };

        SaleView.prototype.decreaseDiscountPercent = function (step) {
            if (!this.isReadOnly && !this.hasGiftItems && this.checkSalePartnerSettings(SaleSettings.UPDATE_DISCOUNT)) {
                if (this.discountPercent - step < 0)
                    this.discountPercent = 0;
                else
                    this.discountPercent -= step;
                this.resetPayments();
                this.calculateSaleFields();
            }

        };

        SaleView.prototype.updateAdvancePercent = function (number) {
            if ((this.advancePercent + number) >= 0 && (this.advancePercent + number) <= 50) {
                this.advancePercent += number;

                this.currentPayment = Math.round(this.price * this.advancePercent) / 100;
                this.currentPaymentInput = $filter('currencyFormatFilter')(this.currentPayment);
            }
        };

        SaleView.prototype.updateAdvancePercentFromCurrentPayment = function () {
            this.advancePercent = this.currentPayment / this.price * 100;
        };

        SaleView.prototype.onCurrentPaymentInputChange = function () {
            if (this.currentPaymentInput != null && typeof this.currentPaymentInput === 'string') {
                var currentPaymentStr = CurrencyManager.getPriceFromPriceInput(this.currentPaymentInput);
                var currentPayment = parseFloat(currentPaymentStr);
                if (currentPayment !== "NaN")
                    this.currentPayment = currentPayment;
                else
                    this.currentPayment = null;
            }
        };

        SaleView.prototype.updateHasUnpaid = function () {
            this.hasUnpaid = false;
            for (let i = 0; i < this.paymentsView.length; i++)
                if (this.paymentsView[i].type === "UNPAID")
                    this.hasUnpaid = true;
        };

        SaleView.prototype.setCurrentPaymentToMax = function () {
            this.payedPrice = 0;
            for (let i = 0; i < this.paymentsView.length; i++)
                this.payedPrice += this.paymentsView[i].price;
            this.currentPayment = this.price - this.payedPrice;
            this.currentPaymentInput = $filter('currencyFormatFilter')(this.currentPayment);
        };

        SaleView.prototype.setCurrentPayment = function (price) {
            this.currentPayment = price;
            this.currentPaymentInput = $filter('currencyFormatFilter')(this.currentPayment);
        };

        SaleView.prototype.addPaymentView = function (type, giftItemView, otherPaymentTypeView) {
            //type : type of payment ex : CB
            //giftItemView : giftItem used for payment
            // otherPaymentTypeView : other type of payment
            this.payedPrice = 0;
            for (let i = 0; i < this.paymentsView.length; i++)
                this.payedPrice += this.paymentsView[i].price;
            let price = this.currentPayment;
            let letToPay = this.price - this.payedPrice - this.currentPayment;
            if (letToPay <= 0) {
                price = this.price - this.payedPrice;
                this.change = -letToPay;
            } else
                this.change = 0;
            if (letToPay < 0)
                letToPay = 0;
            if (price <= 0)
                alert("Le montant du paiement ne peut dépasser la somme à payer.");
            else {
                if (this.form.nbPayments != null && typeof this.form.nbPayments === 'string') {
                    let nbPaymentsStr = CurrencyManager.getPriceFromPriceInput(this.form.nbPayments);
                    this.form.nbPayments = parseInt(nbPaymentsStr);
                }
                this.currentPayment = letToPay;
                this.currentPaymentInput = $filter('currencyFormatFilter')(letToPay);
                this.payedPrice += price;
                let date = null;
                if (this.form.nbPayments > 1) {
                    let dividedPrice = Math.round(price / this.form.nbPayments * 100) / 100;

                    if (this.paymentsView.length !== 0 && this.paymentsView[this.paymentsView.length - 1].date != null)// If another payment exist add one month to set first payment of multi payments
                    {
                        date = new Date(this.paymentsView[this.paymentsView.length - 1].date);
                        date.setMonth(date.getMonth() + 1);
                    }
                    for (let i = 0; i < this.form.nbPayments - 1; i++) {
                        let paymentView = new PaymentView(null, this);
                        paymentView.init(type, dividedPrice, date, otherPaymentTypeView);
                        this.paymentsView.push(paymentView);
                        price -= dividedPrice;
                        date = new Date(paymentView.date);
                        date.setMonth(date.getMonth() + 1);
                    }
                    this.form.nbPayments = 1;

                }


                let paymentView = new PaymentView(null, this);
                paymentView.init(type, price, date, otherPaymentTypeView);
                this.paymentsView.push(paymentView);

                if (giftItemView !== undefined && giftItemView) {
                    if (this.bookingView)
                        paymentView.canDelete = !this.bookingView.containsGiftOnBs(giftItemView);
                    paymentView.giftItemView = giftItemView;
                    giftItemView.isUsed = true;
                    giftItemView.paymentSaleView = this;
                    if (this.posView)
                        this.posView.selectors.giftItemToUse.updateCustGiftItemsToUse(this);

                }
                this.form.displayError = false;
            }
            if (type === "GIFT")
                this.calculateEarnedLoyaltyPts();
            if (type === "UNPAID")
                this.hasUnpaid = true;

            if (this.payedPrice >= this.price)// HasFullPayment
                if (this.paymentsView && this.paymentsView.length === 1)//close menu if only one payment
                    this.manageOtherActionsMenu(false, 0);
                else
                    this.manageOtherActionsMenu(true, 0); //Go to root page of but don't close menu

        };

        SaleView.prototype.sendMails = function () {
            var sale = this.getModel();
            if (sale)
                SaleSrv.sendMails(sale);
        };

        SaleView.prototype.removeAllPaymentView = function () {

            for (var i = 0, sec = 0; i < this.paymentsView.length && sec < 100; sec++)
                if (this.paymentsView[i].canDelete)
                    this.removePaymentView(this.paymentsView[i]);
                else
                    i++
        };

        SaleView.prototype.removePaymentView = function (paymentView) {
            if (paymentView) {
                var index = this.paymentsView.indexOf(paymentView);
                if (index != -1) {
                    this.paymentsView.splice(index, 1);

                    this.payedPrice = 0
                    for (var i = 0; i < this.paymentsView.length; i++)
                        this.payedPrice += this.paymentsView[i].price;
                    var letToPay = this.price - this.payedPrice;
                    if (letToPay < 0)
                        letToPay = 0;
                    this.currentPayment = letToPay;
                    this.currentPaymentInput = $filter('currencyFormatFilter')(letToPay);
                    this.change = 0;
                    if (paymentView.giftItemView) {
                        paymentView.giftItemView.isUsed = false;
                        paymentView.giftItemView.paymentSaleView = null;
                        if (this.posView)
                            this.posView.selectors.giftItemToUse.updateCustGiftItemsToUse(this);
                    }
                    if (paymentView.type == "GIFT")
                        this.calculateEarnedLoyaltyPts();
                }
                this.updateHasUnpaid();
            }
        };

        SaleView.prototype.canSale = function () {
            return !this.posView.domainView.scope.isReadOnly() && this.price >= 0 && this.hasFullPayment() && this.canSave() && this.posView && !this.posView.selectors.giftItem.display && this.hasMailAddressForGiftItems();
        };

        SaleView.prototype.canSaleForAdvance = function () {
            let canSale = this.canSale();
            if (this.status === SaleStatus.ADVANCE) {
                canSale = canSale && (this.currentPayment >= 0);
            }
            return canSale;
        };

        //duplication of hasItems with a new comportment for the pos
        SaleView.prototype.hasItemsPos = function () {
            if (this.bookingView) {
                if (this.bookingView.bookingServicesView.length == 0 && this.saleProductsView.length == 0 && this.saleCuresView.length == 0 && this.giftItemsView.length == 0 && this.loyaltyCardItemsView.length == 0)
                    return false;
            } else if (this.saleServicesView.length == 0 && this.saleProductsView.length == 0 && this.saleCuresView.length == 0 && this.giftItemsView.length == 0 && this.loyaltyCardItemsView.length == 0)
                return false;
            return true;
        };

        SaleView.prototype.hasItems = function () {
            if (this.bookingView) {
                if ((this.bookingView.bookingServicesView.length == 0 && this.saleProductsView.length == 0 && this.saleCuresView.length == 0 && this.giftItemsView.length == 0 && this.loyaltyCardItemsView.length == 0) ||
                    (this.saleCuresView.length != 0 && !this.customerView))  //cant sale a cure if no customer
                    return false;
            } else if ((this.saleServicesView.length == 0 && this.saleProductsView.length == 0 && this.saleCuresView.length == 0 && this.giftItemsView.length == 0 && this.loyaltyCardItemsView.length == 0) ||
                (this.saleCuresView.length != 0 && !this.customerView)) //cant sale a cure if no customer
                return false;
            return true;
        };

        SaleView.prototype.hasItemsOtherThanService = function () {
            return this.saleProductsView.length != 0 || this.saleCuresView.length != 0 || this.giftItemsView.length != 0 || this.loyaltyCardItemsView.length != 0
        };

        SaleView.prototype.canSave = function () {
            if (this.posView.domainView.scope.isReadOnly()) {
                return false
            }
            if (this.hasInvalidAmounts) {
                return false;
            }
            if (!this.dayView || (!this.customerView && !this.isOccasionalCustomer) || (this.customerView && !this.customerView.canSave()) || (this.customerView && (this.form.displayErrorLandLine || this.form.displayErrorMobile)))
                return false;
            if (this.bookingView) {
                if (!this.bookingView.canSave())
                    return false;
                if ((this.bookingView.bookingServicesView.length == 0 && this.saleProductsView.length == 0 && this.saleCuresView.length == 0 && this.giftItemsView.length == 0 && this.loyaltyCardItemsView.length == 0) ||
                    (this.saleCuresView.length != 0 && !this.customerView))  //cant sale a cure if no customer
                    return false;
            } else if ((this.saleServicesView.length == 0 && this.saleProductsView.length == 0 && this.saleCuresView.length == 0 && this.giftItemsView.length == 0 && this.loyaltyCardItemsView.length == 0) ||
                (this.saleCuresView.length != 0 && !this.customerView)) //cant sale a cure if no customer
                return false;
            let originalPrice = Math.round((this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice) * 100) / 100;
            if (this.price > originalPrice || !this.isValidLoyaltyPoints) {
                return false;
            }
            return true;
        };

        SaleView.prototype.hasMailAddressForGiftItems = function () {
            let hasMail = true;
            if (!this.hasCustomerWithEmail()) {
                if (this.giftItemsView.length > 0) {
                    for (let i = 0; i < this.giftItemsView.length; i++) {
                        if (this.giftItemsView[i].editionType === "email" && (!this.giftItemsView[i].hasCustomerWithEmail())) {
                            hasMail = false;
                            this.displayGiftItemMailRecipientError = true;
                            break;
                        }
                    }
                }
            }
            return hasMail;
        };

        SaleView.prototype.hasCustomerWithEmail = function () {
            return this.customerView && this.customerView.email;
        };

        SaleView.prototype.hasFullPayment = function () {
            var payed = 0;
            for (var i = 0; i < this.paymentsView.length; i++)
                payed += this.paymentsView[i].price;
            payed = Math.round(payed * 100);
            return (Math.round(this.price * 100) - payed) <= 0;
        };

        SaleView.prototype.hasGiftItemPayment = function () {
            let hasGiftItemPayment = this.paymentsView.find(paymentView => paymentView.type === "GIFT");
            return hasGiftItemPayment != null;
        };

        SaleView.prototype.resetPayments = function (force) {
            if (this.status != "advance" || force)//no reset on advance
            {
                if (this.bookingView) {
                    for (var i = 0; i < this.paymentsView.length;)// remove only if bookingservice isnt linked to payment.gift or online payment
                        if (this.paymentsView[i].type != "CBONLINE" && (!this.paymentsView[i].giftItemView || !this.bookingView.containsGiftOnBs(this.paymentsView[i].giftItemView)))
                            this.paymentsView.splice(i, 1);
                        else
                            i++;
                } else
                    this.paymentsView = [];
                this.change = 0;
                this.payedPrice = 0;
                if (this.posView && this.posView.selectors && this.posView.selectors.giftItemToUse)
                    this.posView.selectors.giftItemToUse.updateCustGiftItemsToUse(this);
            }
        };

        SaleView.prototype.updatePaymentsForADate = function (date, otherPaymentTypesView) {
            this.paymentsForADate.initSalePaymentsPrice();
            this.paymentsForADate.hasSpecificPaymentDate = false;
            this.paymentsForADate.otherPaymentTypePrices = this.initOtherPaymentTypeForADate(otherPaymentTypesView);
            this.paymentsForADate.price = 0;
            this.paymentsForADate.nbPayments = 0;
            this.paymentsForADate.priceHT = 0;
            if (this.status != "canceled" && this.status != "credit") {
                var fullYear = date.getFullYear();
                var month = date.getMonth();
                var day = date.getDate();
                if (this.timeCreated)
                    this.paymentsForADate.hasSpecificPaymentDate = !(this.timeCreated.getFullYear() == fullYear &&
                        this.timeCreated.getMonth() == month &&
                        this.timeCreated.getDate() == day);
                var paymentsDate = [];
                var index = 0;
                var dayId;
                var time;
                var match = false;
                for (var j = 0; j < this.paymentsView.length; j++) {
                    time = this.paymentsView[j].date.getTime();

                    match = false;
                    if (this.paymentsView[j].date && time != 0 && !isNaN(time)) {
                        dayId = DaySrv.getIdFromDate(this.paymentsView[j].date);
                        index = paymentsDate.indexOf(dayId);
                        if (index == -1)
                            paymentsDate.push(dayId);
                    } else
                        match = true;
                    if (!match)
                        match = (this.paymentsView[j].date.getFullYear() == fullYear &&
                            this.paymentsView[j].date.getMonth() == month &&
                            this.paymentsView[j].date.getDate() == day)
                    if (match) {
                        let salePaymentType = SalePaymentTypeFactory.from(sale.payments[j].type);
                        if (salePaymentType) {
                            this.paymentsForADate[salePaymentType.keyPrice] += this.paymentsView[j].price;
                        } else if (this.paymentsView[j].otherPaymentTypeView) {
                            this.addOtherPaymentTypeForADate(otherPaymentTypesView, this.paymentsForADate.otherPaymentTypePrices, this.paymentsView[j].otherPaymentTypeView, this.paymentsView[j].price);
                        }
                    }
                }
                paymentsDate.sort();
                this.paymentsForADate.nbPayments = paymentsDate.length;
                this.paymentsForADate.paymentNumber = paymentsDate.indexOf(DaySrv.getIdFromDate(date)) + 1;
                this.paymentsForADate.price = Math.round(this.paymentsForADate.computeTotalSalePaymentsPrice() * 100) / 100;

                for (var j = 0; j < this.paymentsForADate.otherPaymentTypePrices.length; j++)
                    this.paymentsForADate.price += this.paymentsForADate.otherPaymentTypePrices[j];
                this.paymentsForADate.price = Math.round((this.paymentsForADate.price) * 100) / 100;

                //this.paymentsForADate.priceHT = Math.round((this.paymentsForADate.price  * 1000/(100+this.vat))*100)/1000;  //TODO
                this.paymentsForADate.hasSamePriceThanSale = (Math.round(this.paymentsForADate.price * 100) / 100) == (Math.round(this.price * 100) / 100);
            }
        };

        SaleView.prototype.initOtherPaymentTypeForADate = function (otherPaymentTypesView) {
            var optypes = [];
            if (otherPaymentTypesView)
                for (var i = 0; i < otherPaymentTypesView.length; i++)
                    optypes.push(0);
            return optypes;
        };

        SaleView.prototype.addOtherPaymentTypeForADate = function (otherPaymentTypesView, otherPaymentTypePrices, optView, amount) {
            if (otherPaymentTypesView) {
                for (var i = 0; i < otherPaymentTypesView.length; i++)
                    if (otherPaymentTypesView[i] === optView) {
                        otherPaymentTypePrices[i] += amount;
                        return;
                    }

            }
        };

        SaleView.prototype.sell = function (successFunction, errorFunction) {
            if (this.status === "created" || this.status === "waiting" || this.status === "advance") {
                if (this.bookingView) {
                    this.saleServicesView = [];
                    for (var i = 0; i < this.bookingView.bookingServicesView.length; i++) {
                        if (!this.bookingView.bookingServicesView[i].cureItemToServiceUsageView)
                            this.addBookingServiceOnSale(this.bookingView.bookingServicesView[i]);
                    }
                }
                this.setStatus("sold");
            }
            var saleView = this;
            this.updateSellerFromItems();
            if (this.bookingView)
                this.bookingView.updateModel(null, BookingSaveTransactionOrigin.SOLD_SALE); //must be done before sale creation, bookingId managed by ServerSrv pool
            this.updateModel(null, successFunction, errorFunction);

        };

        SaleView.prototype.keepAdvance = function (endFunction) {
            if (this.status == "advance") {
                this.remvoveLoyaltyGoal();//Force remove of Loyalty to avoid negative tickets
                this.saleServicesView = [];
                this.saleProductsView = [];
                this.saleCuresView = [];
                this.giftItemsView = [];
                this.loyaltyCardItemsView = [];
                var saleProductView = new SaleProductView(null, -1, 0, this);
                saleProductView.label = "Acompte conservé";
                saleProductView.originalPrice = this.payedPrice;
                saleProductView.price = this.payedPrice;
                saleProductView.quantity = 1;
                saleProductView.updatePriceHT();
                this.addSaleProductView(saleProductView, true);
                this.setStatus("advanceKeeped");
            }
            var saleView = this;
            this.updateModel(null, endFunction);

        };

        SaleView.prototype.cancelSaleAction = function (successFunction, errorFunction) {

            if (this.isCreatedByCustomer && (!this.canRefundGiftItem || !this.transformToGiftOnCancel))//try to refund
            {
                var saleView = this;
                if (saleView.posView)
                    saleView.posView.domainView.pTView.loading = true;

                SaleSrv.refund(this.getModel(), function () {
                    saleView.cancelSaleFinalAction(successFunction, errorFunction);
                    if (saleView.posView) {
                        saleView.posView.domainView.pTView.loading = false;
                        saleView.posView.loadSale();
                    }

                }, function (error) {
                    var sentence = "Erreur remboursement impossible.";
                    if (error && error.data) {
                        if (error.data.errorCode == "005407")
                            sentence = "Vous ne pouvez pas effectuer deux demandes de remboursement la même journée";
                        if (error.data.errorCode == "002999")
                            sentence = "Vous devez certifier votre compte de paiement " + Brand.label + " (KYC)";
                        if (error.data.errorCode == "005405")
                            sentence = "Vous ne disposez pas d'assez d'argent sur votre compte " + Brand.label;
                    }
                    saleView.posView.domainView.pTView.loading = false;
                    var opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/errorDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                var tableModel = [];
                                tableModel["label"] = sentence;
                                return tableModel;
                            }
                        }
                    };
                    $dialog.dialog(opts).open();
                })
            } else
                this.cancelSaleFinalAction(successFunction, errorFunction);
        };

        SaleView.prototype.cancelSaleFinalAction = function (successFunction, errorFunction) {
            if (this.status === "sold" || this.status === "advance") {
                this.setStatus("canceled");
                var creditSaleView = this.getClone(this.creditDayView);
                creditSaleView.advanceNumber = this.advanceNumber;
                creditSaleView.estimationNumber = this.estimationNumber;
                creditSaleView.canceledSaleNumber = this.saleNumber;
                creditSaleView.isCreatedByCustomer = this.isCreatedByCustomer;
                creditSaleView.delivery = this.delivery;
                creditSaleView.deliveryMsg = this.deliveryMsg;
                creditSaleView.techNote = this.techNote;
                creditSaleView.comment = this.comment;
                creditSaleView.advancePrice = this.advancePrice;
                creditSaleView.setStatus("credit");
                creditSaleView.price = -creditSaleView.price;
                creditSaleView.priceHT = -creditSaleView.priceHT;
                creditSaleView.servicesPrice = -creditSaleView.servicesPrice;
                creditSaleView.productsPrice = -creditSaleView.productsPrice;
                creditSaleView.curesPrice = -creditSaleView.curesPrice;
                creditSaleView.giftItemsPrice = -creditSaleView.giftItemsPrice;
                creditSaleView.loyaltyCardsPrice = -creditSaleView.loyaltyCardsPrice;
                creditSaleView.servicesPriceWithD = -creditSaleView.servicesPriceWithD;
                creditSaleView.productsPriceWithD = -creditSaleView.productsPriceWithD;
                creditSaleView.curesPriceWithD = -creditSaleView.curesPriceWithD;
                creditSaleView.giftItemsPriceWithD = -creditSaleView.giftItemsPriceWithD;
                creditSaleView.loyaltyCardsPriceWithD = -creditSaleView.loyaltyCardsPriceWithD;


                for (var i = 0; i < creditSaleView.paymentsView.length; i++) {
                    creditSaleView.paymentsView[i].price = -creditSaleView.paymentsView[i].price;
                    if (creditSaleView.paymentsView[i].giftItemView)//gift item is no more used
                    {
                        if (!this.bookingView || !this.bookingView.containsGiftOnBs(creditSaleView.paymentsView[i].giftItemView))
                            creditSaleView.paymentsView[i].giftItemView.isUsed = false;
                        creditSaleView.paymentsView[i].giftItemView.paymentSaleView = null;
                    }
                }

                for (var i = 0; i < this.saleServicesView.length; i++)
                    creditSaleView.saleServicesView[i].setPriceAsCredit();
                for (var i = 0; i < this.saleProductsView.length; i++) {
                    creditSaleView.saleProductsView[i].price = -creditSaleView.saleProductsView[i].price;

                    if (this.saleProductsView[i].productView && this.saleProductsView[i].productView.hasQuantity)//reput product on productview stock
                        this.saleProductsView[i].productView.quantity += this.saleProductsView[i].quantity;
                }
                for (var i = 0; i < this.saleCuresView.length; i++)
                    creditSaleView.saleCuresView[i].price = -creditSaleView.saleCuresView[i].price;
                for (var i = 0; i < this.giftItemsView.length; i++)
                    creditSaleView.giftItemsView[i].price = -creditSaleView.giftItemsView[i].price;
                for (var i = 0; i < this.loyaltyCardItemsView.length; i++)
                    creditSaleView.loyaltyCardItemsView[i].price = -creditSaleView.loyaltyCardItemsView[i].price;
                if (this.bookingView) {
                    this.bookingView.saleView = null;
                    this.bookingView.updateModel(null, BookingSaveTransactionOrigin.CANCELED_SALE);
                }

                var saleTransaction = new Transaction();
                this.updateModel(saleTransaction);
                creditSaleView.updateModel(saleTransaction);
                if (this.isCreatedByCustomer) {
                    // SlackSrv.sendMessage("GiftItem cancelSale - SaleView - cancelSaleFinalAction " + this.id);
                }
                SaleSrv.executeTransaction(saleTransaction, successFunction, errorFunction);
            }
        };

        SaleView.prototype.checkCreditDayView = function () {

            this.creditDayView = null;
            if (this.dayView) {
                var oDay = DayData.getOpenDay(-1)
                if (oDay) {
                    var cDay = this.dayView.getModel();
                    if (cDay === oDay)
                        this.creditDayView = this.dayView;
                    else {
                        this.creditDayView = new DayView(DayData.getIndexOf(oDay));
                    }
                } else {
                    var opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/infoDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                var tableModel = [];
                                tableModel["label"] = "Vous ne pouvez pas annuler ce ticket car il n'existe aucune journée ouverte.";
                                return tableModel;
                            }
                        }
                    };
                    $dialog.dialog(opts).open();
                    return false;
                }
            }
            return this.creditDayView != null;

        };

        SaleView.prototype.cancelSale = function (successFunction, errorFunction) {
            var saleView = this;
            //check if can cancel
            if (this.checkCreditDayView() && this.canCancelSale()) {
                this.updateRefundGiftItem();
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/planningPos/pos/form/cancelConfirm.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function () {
                            var tableModel = [];
                            if (saleView.customerView)
                                tableModel["label"] = " le ticket pour " + saleView.customerView.label;
                            else
                                tableModel["label"] = " le ticket en cours";
                            tableModel["saleView"] = saleView;
                            return tableModel;
                        }
                    }
                };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result) {
                        saleView.cancelSaleAction(function () {
                            if (successFunction !== undefined)
                                successFunction();
                        }, function (data) {
                            if (data !== undefined && errorFunction !== undefined)
                                errorFunction(data);
                        });
                    }
                });
            }
        };

        SaleView.prototype.canChangeDay = function () {

            if (this.status === "created" || this.status === "waiting")
                return true;
            if (this.status === "advance" || this.status === "sold" && this.dayView) {
                var cDay = this.dayView.getModel();
                if (cDay && !(cDay.closure && cDay.closure.status === "closed"))
                    return true;
            }
            return false;
        };

        SaleView.prototype.canChangeDayTo = function (dayId) {

            if (this.status === "created" || this.status === "waiting")
                return true;
            var cDay = this.dayView.getModel();
            if (cDay && cDay.id != dayId) {
                var tDay = DayData.getById(dayId);
                var dayView = new DayView(DayData.getIndexOf(tDay));
                if (dayView) {
                    if ((this.status == "sold" || this.status == "advance") && !(tDay.closure && tDay.closure.status == "closed"))
                        return true;
                }
            }
            return false;
        };

        SaleView.prototype.hasGiftItemUsed = function () {
            let usedGiftItemView = this.giftItemsView.find(giftItemView => giftItemView.isUsed === true);
            return usedGiftItemView != null;
        }

        SaleView.prototype.hasSaleCureWithUsage = function () {
            let saleCureWithCureItem = this.saleCuresView.find(saleCureView => saleCureView.hasCureItemUsage());
            return saleCureWithCureItem != null;
        }

        SaleView.prototype.save = function () {
            this.setStatus("waiting");
            if (this.bookingView)
                this.bookingView.updateModel(null, BookingSaveTransactionOrigin.WAITING_SALE);//generate id

            this.updateModel();
        };

        SaleView.prototype.openPrintWindow = function () {
            var left = (screen.width / 2) - (800 / 2);
            var top = (screen.height / 2) - (500 / 2);
            this.printWindow = window.open('', '_blank', 'width=800,height=500,left=' + left + ',top=' + top + ',scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
            if (this.printWindow)
                this.printWindow.window.focus();
        };

        SaleView.prototype.onLoyaltyPtsChange = function () {
            if (this.loyaltyPts != null) {
                if (typeof this.loyaltyPts === 'string') {
                    let loyaltyPtsStr = CurrencyManager.getPriceFromPriceInput(this.loyaltyPts);
                    this.loyaltyPts = parseInt(loyaltyPtsStr);
                }
                this.checkLoyaltyPointsValid();
            }
        };

        SaleView.prototype.onLoyaltyUsedPtsChange = function () {
            if (this.loyaltyUsedPts != null) {
                if (typeof this.loyaltyUsedPts === 'string') {
                    let loyaltyPtsStr = CurrencyManager.getPriceFromPriceInput(this.loyaltyUsedPts);
                    this.loyaltyUsedPts = parseInt(loyaltyPtsStr);
                }
            }
        };

        SaleView.prototype.checkLoyaltyPointsValid = function () {
            if (isNaN(this.loyaltyPts) || (this.loyaltyCardItemView.pts + this.loyaltyPts) < 0) {
                this.isValidLoyaltyPoints = false;
            } else {
                this.isValidLoyaltyPoints = true;
            }
        };

        SaleView.prototype.increaseLoyaltyPts = function (step) {
            if (!this.isReadOnly) {
                if (typeof step === 'string') {
                    step = parseInt(step);
                }
                this.loyaltyPts += step;
                this.checkLoyaltyPointsValid();
            }
        };

        SaleView.prototype.increaseLoyaltyUsedPts = function (step) {
            if (!this.isReadOnly) {
                if (typeof step === 'string') {
                    step = parseInt(step);
                }
                this.loyaltyUsedPts += step;
            }
        };

        SaleView.prototype.updateSellerFromItems = function () {
            this.hrSellerView = null;
            if (this.bookingView && (this.status == "created" || this.status == "waiting" || this.status == "advance" || this.status == "soldProcess" || this.status == "advanceProcess") &&
                this.bookingView.bookingServicesView.length > 0 && this.bookingView.bookingServicesView[0].plgDayHrView && this.bookingView.bookingServicesView[0].plgDayHrView.hrView)
                this.hrSellerView = this.bookingView.bookingServicesView[0].plgDayHrView.hrView;
            else {
                if (this.saleServicesView.length > 0) {
                    if (this.saleServicesView[0].subSaleServicesView.length > 0 && this.saleServicesView[0].subSaleServicesView[0].hrView) {
                        this.hrSellerView = this.saleServicesView[0].subSaleServicesView[0].hrView;
                    } else if (this.saleServicesView[0].hrView) {
                        this.hrSellerView = this.saleServicesView[0].hrView;
                    }
                }
                if (!this.hrSellerView && this.saleProductsView.length > 0 && this.saleProductsView[0].hrView)
                    this.hrSellerView = this.saleProductsView[0].hrView;
                if (!this.hrSellerView && this.saleCuresView.length > 0 && this.saleCuresView[0].hrView)
                    this.hrSellerView = this.saleCuresView[0].hrView;
                if (!this.hrSellerView && this.giftItemsView.length > 0 && this.giftItemsView[0].hrView)
                    this.hrSellerView = this.giftItemsView[0].hrView;
                if (!this.hrSellerView && this.loyaltyCardItemsView.length > 0 && this.loyaltyCardItemsView[0].hrView)
                    this.hrSellerView = this.loyaltyCardItemsView[0].hrView;
            }

            if (this.hrSellerView == null)
                this.hrOpView = null;
            else if (this.hrOpView == null)
                this.hrOpView = this.hrSellerView;
        };

        SaleView.prototype.getDiscount = function (saleItem, quantity) {
            var discountTTC = 0;
            if (saleItem.discountPercent > 0) {
                if (saleItem.discountPercent == 100)
                    discountTTC = saleItem.originalPrice * quantity;
                else {
                    discountTTC = saleItem.price / (1 - saleItem.discountPercent / 100) - saleItem.price;
                }
            }
            return discountTTC;
        };

        SaleView.prototype.getDiscountGlobalTTC = function (saleItem, discountTTC) {
            var discountRemise = 0;
            if (this.discountPercent > 0 && discountTTC != saleItem.originalPrice) {
                discountRemise += saleItem.price * this.discountPercent / 100;
            }
            return discountRemise;
        };

        SaleView.prototype.addLine = function (saleItem, quantity, discountTTC, label) {
            let vat = (saleItem.vat || saleItem.vat === 0) ? saleItem.vat : "20";
            let price = saleItem.originalPrice;
            let priceHT = saleItem.originalPrice / ((vat / 100) + 1);
            let finalLabel = priceHT == 0 ? label + "</br>" + gettextCatalog.getString("Code 328 gratuité totale") : label;
            var lineContent = '' +
                '<tr>' +
                '<td style="width:13px">' + quantity + '</td>' +
                '<td>' + finalLabel + '</td>' +
                '<td>' + gettextCatalog.getString("Code TVA") + " : " + saleItem.vatCode + '</td>' +
                '<td>' + gettextCatalog.getString("TVA") + ' = ' + vat + '%</td>' +
                '<td>' + gettextCatalog.getString("Prix Unitaire HT") + ' = ' + $filter('currencyFormatFilter')(priceHT) + '</td>' +
                '<td>' + gettextCatalog.getString("Prix Unitaire TTC") + ' = ' + $filter('currencyFormatFilter')(price) + '</td>' +
                '<td>' + gettextCatalog.getString("Prix Total HT") + ' = ' + $filter('currencyFormatFilter')(priceHT * quantity) + '</td>' +
                '<td>' + gettextCatalog.getString("Prix Total TTC") + ' = ' + $filter('currencyFormatFilter')(price * quantity) + '</td>' +
                '</tr>';
            var discountP = discountTTC * 100 / (saleItem.originalPrice * quantity);
            if (discountP > 0) {
                lineContent += '' +
                    '<tr>' +
                    '<td style="width:13px"></td>' +
                    '<td style="font-style: italic"><span>' + gettextCatalog.getString("Remise de") + '</span> ' + $filter('number')(discountP, 2) + '%</td>' +
                    '<td></td>' +
                    '<td class="price">-' + $filter('currencyFormatFilter')(discountTTC) + '</td>' +
                    '</tr>';
            }
            return lineContent;
        };

        SaleView.prototype.printSell = function (printSite, dSignatureCode) {
            let site = printSite;
            if (this.printWindow) {
                if (this.site) {
                    site = new Site(this.site);
                } else if (!site) {
                    site = SiteData.defaultSite;
                }

                //'</head><body onload="window.print();setTimeout(function(){window.close();}, 1);"><div class="reward-body">' +
                let onLoadContent = "window.print();setTimeout(function(){window.close();}, 1);";
                if (IOSDevice.isIOSDevice()) {
                    onLoadContent = "window.print();";
                }

                let documentContent = '<!DOCTYPE html><html><head>' +
                    '<link rel="stylesheet" type="text/css" href="/css/print.css" />' +
                    '<script src="//ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js"></script>' +
                    '<script src="/lib/barcode/JsBarcode.js"></script>' +
                    '<script src="/lib/barcode/EAN_UPC.js"></script>' +
                    '</head><body onload="' + onLoadContent + '"><div class="reward-body">' +
                    '<div class="company">' +
                    '<div class="name">' + site.name + '</div>';

                if (site.siret && site.siret !== "" && site.isFrenchLocation()) {
                    documentContent += '<div class="address">' + gettextCatalog.getString("N° siret") + " : " + site.siret + '</div>';
                }
                if (site.vatNumber && site.vatNumber !== "") {
                    documentContent += '<div class="address">' + gettextCatalog.getString("N° TVA") + " : " + site.vatNumber + '</div>';
                }
                if (site.rcs && site.rcs !== "") {
                    documentContent += '<div class="address">' + gettextCatalog.getString("N°RCS") + " : " + site.rcs + '</div>';
                }
                if (site.nafCode && site.nafCode !== "") {
                    documentContent += '<div class="address">' + gettextCatalog.getString("Code NAF") + " : " + site.nafCode + '</div>';
                }
                if (this.status === 'advance') {
                    const juridicForm = this.juridicForm ? this.juridicForm : '';
                    const greffeCity = this.greffeCity ? ' Immatriculé au Greffe de : ' + this.greffeCity : '';
                    const shareCapital = this.shareCapital ? 'Société au capital de : ' + this.shareCapital : '';
                    documentContent += '<div class="address"> ' + juridicForm + greffeCity + '</div>';
                    documentContent += '<div class="address">' + shareCapital + '</div>';
                }
                if (site.address && site.address !== "") {
                    documentContent += '<div class="address">' + site.address + '</div>';
                    documentContent += '<div class="address">' + site.postalCode + ' ' + site.city;

                    if (Countries.map[site.country]) {
                        documentContent += ' ' + Countries.map[site.country].countryName;
                    }
                    documentContent += '</div>';
                }

                if (site.phone && site.phone !== "") {
                    documentContent += '<div class="phone">' + site.phone + '</div>';
                }
                if (this.dayView) {
                    let currentDateTime = new Date();
                    let labelDate = $filter('date')(currentDateTime, 'EEEE d MMMM yyyy');
                    let labelTime = gettextCatalog.getString("A_TIME") + ' ' + $filter('date')(currentDateTime, "H':'mm':'ss.sss");
                    let labelDateTimeCapitalized = labelDate.charAt(0).toUpperCase() + labelDate.substring(1) + ' ' + labelTime;
                    documentContent += '</div>' +
                        '<div class="global-info">' +
                        '<div class="date">' + gettextCatalog.getString("Date") + " : " + labelDateTimeCapitalized + '</div>';
                }
                if (this.hrSellerView && this.isEstimationCost()) {
                    documentContent += '<div class="hr">' + gettextCatalog.getString("Créé par") + ' : ' + this.hrSellerView.label + '</div>';
                } else if (this.hrSellerView) {
                    documentContent += '<div class="hr">' + gettextCatalog.getString("Encaissé par") + " : " + this.hrSellerView.label + '</div>';
                }
                if (this.customerView && this.status !== 'advance') {
                    documentContent += '<div class="customer">' + gettextCatalog.getString("Client") + " : " + this.customerView.firstName + ' ' + this.customerView.lastName + '</div>';
                } else if (this.customerLastname && this.customerFirstname) {
                    documentContent += '<div class="customer">' + gettextCatalog.getString("Client") + " : " + this.customerFirstname + ' ' + this.customerLastname + '</div>';
                    if (this.customerAddress && this.customerZip && this.customerCity) {
                        documentContent += '<div class="customer">' + this.customerAddress + ' ' + this.customerCity + ' ' + this.customerZip + '</div>';
                    }
                } else {
                    documentContent += '<div class="customer">' + gettextCatalog.getString("Client") + " : " + gettextCatalog.getString("De passage") + '</div>';
                }

                if (this.saleNumber) {
                    let nbItems = this.saleServicesView.length + this.saleProductsView.length + this.saleCuresView.length + this.giftItemsView.length + this.loyaltyCardItemsView.length;
                    documentContent += '<div class="customer">' + gettextCatalog.getString("Ticket n°") + " : " + this.saleNumber + ' (' + nbItems + ' lig.) / ' + this.statusLabel[this.status] + '</div>';
                } else if (this.advanceNumber) {
                    let nbItems = this.saleServicesView.length + this.saleProductsView.length + this.saleCuresView.length + this.giftItemsView.length + this.loyaltyCardItemsView.length;
                    documentContent += '<div class="customer">' + gettextCatalog.getString("Facture d'acompte n°") + " : " + this.advanceNumber + ' (' + nbItems + ' lig.)</div>';
                }

                if (this.estimationNumber) {
                    let estimationLabel = gettextCatalog.getString("Devis n°");
                    let nbItems = this.saleServicesView.length + this.saleProductsView.length + this.saleCuresView.length + this.giftItemsView.length + this.loyaltyCardItemsView.length;
                    documentContent += '<div class="customer">' + estimationLabel + ' : ' + this.estimationNumber + ' (' + nbItems + ' lig.)</div>';
                }

                if (this.signatureCode && !this.isEstimationCost()) {
                    documentContent += '<div class="customer">' + gettextCatalog.getString("Signature ticket") + " : " + this.signatureCode + '</div>';
                }
                if (this.posView && this.posView.domainView.scope.ad.loggedUser.serverIdentification.version) {
                    documentContent += '<div class="customer">' + gettextCatalog.getString("Logiciel") + " : " + Brand.label + ' V' + this.computeSoftV() + '(NF525)</div>';
                }

                if (this.nbPrint > 1 && this.status !== 'estimation') {
                    documentContent += '<div class="customer">' + gettextCatalog.getString("Duplicata n°") + (this.nbPrint - 1);
                    if (dSignatureCode !== undefined && dSignatureCode && dSignatureCode !== '') {
                        documentContent += ' (' + dSignatureCode + ')';
                    }
                    documentContent += '</div>';
                }
                documentContent += '</div><table class="bill">';

                let saleDiscountTTC = 0;
                let saleItemDiscountTTC = 0;
                let totalTTC = 0;

                for (let i = 0; i < this.saleServicesView.length; i++) {
                    let discountTTC = this.getDiscount(this.saleServicesView[i], 1);
                    totalTTC += this.saleServicesView[i].originalPrice;
                    saleDiscountTTC += discountTTC;
                    saleItemDiscountTTC = this.getDiscountGlobalTTC(this.saleServicesView[i], discountTTC) + saleItemDiscountTTC;
                    documentContent += this.addLine(this.saleServicesView[i], 1, discountTTC, this.saleServicesView[i].label);
                }

                for (let i = 0; i < this.saleProductsView.length; i++) {
                    let discountTTC = this.getDiscount(this.saleProductsView[i], this.saleProductsView[i].quantity);
                    totalTTC += this.saleProductsView[i].originalPrice * this.saleProductsView[i].quantity;
                    saleDiscountTTC += discountTTC;
                    saleItemDiscountTTC = this.getDiscountGlobalTTC(this.saleProductsView[i], discountTTC) + saleItemDiscountTTC;
                    documentContent += this.addLine(this.saleProductsView[i], this.saleProductsView[i].quantity, discountTTC, this.saleProductsView[i].label);
                }

                for (let i = 0; i < this.saleCuresView.length; i++) {
                    let discountTTC = this.getDiscount(this.saleCuresView[i], this.saleCuresView[i].quantity);
                    totalTTC += this.saleCuresView[i].originalPrice * this.saleCuresView[i].quantity;
                    saleDiscountTTC += discountTTC;
                    saleItemDiscountTTC = this.getDiscountGlobalTTC(this.saleCuresView[i], discountTTC) + saleItemDiscountTTC;
                    documentContent += this.addLine(this.saleCuresView[i], this.saleCuresView[i].quantity, discountTTC, this.saleCuresView[i].label);
                }

                for (let i = 0; i < this.loyaltyCardItemsView.length; i++) {
                    let discountTTC = this.getDiscount(this.loyaltyCardItemsView[i], 1);
                    totalTTC += this.loyaltyCardItemsView[i].originalPrice;
                    saleDiscountTTC += discountTTC;
                    saleItemDiscountTTC = this.getDiscountGlobalTTC(this.loyaltyCardItemsView[i], discountTTC) + saleItemDiscountTTC;
                    documentContent += this.addLine(this.loyaltyCardItemsView[i], 1, discountTTC, this.loyaltyCardItemsView[i].label);
                }

                let totalDiscountTTC = saleItemDiscountTTC + saleDiscountTTC;

                if (this.discountPercent !== 0 && saleItemDiscountTTC) {
                    let gratuityLabel = this.discountPercent >= 100 ? gettextCatalog.getString("</br>Code 328 gratuité totale") : "";
                    documentContent += '' +
                        '<tr>' +
                        '<td colspan="3" style="width:30px">' + gettextCatalog.getString("Remise globale") + ' ' + $filter('number')(this.discountPercent, 2) + '%' + gratuityLabel + '</td>' +
                        '<td class="price">-' + $filter('currencyFormatFilter')(saleItemDiscountTTC) + '</td>' +
                        '</tr>';
                }

                if (this.saleServicesView.length || this.saleProductsView.length || this.saleCuresView.length) {
                    documentContent += '' +
                        '<tr>' +
                        '<td colspan="3" style="font-weight: bold">' + gettextCatalog.getString("Total TTC") + '</td>' +
                        '<td class="price" style="font-weight: bold">' + $filter('currencyFormatFilter')(totalTTC - totalDiscountTTC) + '</td>' +
                        '</tr>';
                }

                if (totalDiscountTTC) {
                    documentContent += '' +
                        '<tr>' +
                        '<td colspan="3">' + gettextCatalog.getString("Total remises TTC") + '</td>' +
                        '<td class="price">' + $filter('currencyFormatFilter')(totalDiscountTTC) + '</td>' +
                        '</tr>';
                }

                documentContent += '</table>';

                documentContent += '<table class="bill">';

                let giftGlobalDiscountTTC = 0;
                let documentContentGift = '';
                for (let i = 0; i < this.giftItemsView.length; i++) {
                    let giftItemView = this.giftItemsView[i];
                    let giftDiscountTTC = this.getDiscount(giftItemView, 1);
                    giftGlobalDiscountTTC += this.getDiscountGlobalTTC(giftItemView, giftDiscountTTC);
                    documentContentGift += '' +
                        '<tr>' +
                        '<td colspan="4">' + gettextCatalog.getString("1 Chèque cadeau") + '</td>' +
                        '<td class="price">' + $filter('currencyFormatFilter')(giftItemView.originalPrice) + '</td>' +
                        '</tr>';
                    if (giftDiscountTTC) {
                        documentContentGift += '' +
                            '<td colspan="4" style="width:30px">' + gettextCatalog.getString("Remise de") + ' ' + $filter('number')(giftItemView.discountPercent, 2) + '%</td>' +
                            '<td class="price">-' + $filter('currencyFormatFilter')(giftDiscountTTC) + '</td>' +
                            '</tr>';
                    }
                }

                if (giftGlobalDiscountTTC) {
                    documentContentGift += '' +
                        '<tr>' +
                        '<td colspan="4">' + gettextCatalog.getString("Remise globale") + ' ' + $filter('number')(this.discountPercent, 2) + '%</td>' +
                        '<td class="price">-' + $filter('currencyFormatFilter')(giftGlobalDiscountTTC) + '</td>' +
                        '</tr>';
                }

                if (documentContentGift !== '') {
                    documentContent += documentContentGift;
                }

                if (this.saleServicesView.length || this.saleProductsView.length || this.saleCuresView.length) {
                    documentContent += '' +
                        '<tr>' +
                        '<td class="price-tva" style="width:30px;text-align: left">' + gettextCatalog.getString("Code") + '</td>' +
                        '<td class="price-tva" style="width:30px"></td>' +
                        '<td class="price-tva">' + gettextCatalog.getString("TOTAL TVA") + '</td>' +
                        '<td class="price-tva">' + gettextCatalog.getString("TOTAL HT") + '</td>' +
                        '<td class="price-tva">' + gettextCatalog.getString("TOTAL TTC") + '</td>' +
                        '</tr>';

                    let totalVat = 0,
                        totalHT = 0,
                        totalTTC = 0;

                    for (let i = 0; i < this.vatLines.length; i++) {
                        if ((this.posView && this.posView.domainView && this.posView.domainView.getDefaultVatTax() === this.vatLines[i].tax)
                            || (this.vatLines[i].amount !== 0 || this.vatLines[i].ht !== 0)) {

                            //var ht = this.vatLines[i].amount / (this.vatLines[i].tax) * 100;
                            let ht = this.vatLines[i].ht;

                            totalVat += (this.vatLines[i].amount ? this.vatLines[i].amount : 0);
                            totalHT += (ht ? ht : 0);
                            totalTTC += (this.vatLines[i].amount ? this.vatLines[i].amount : 0) + (ht ? ht : 0);

                            documentContent += '' +
                                '<tr>' +
                                '<td class="price-tva" style="text-align:left">' + this.vatLines[i].code + '</td>' +
                                '<td class="price-tva">' + $filter('number')(this.vatLines[i].tax, 2) + '%' + '</td>' +
                                '<td class="price-tva">' + $filter('currencyFormatFilter')(this.vatLines[i].amount) + '</td>' +
                                '<td class="price-tva">' + $filter('currencyFormatFilter')(ht) + '</td>' +
                                '<td class="price-tva">' + $filter('currencyFormatFilter')(this.vatLines[i].amount + ht) + '</td>' +
                                '</tr>';
                        }
                    }
                    documentContent += '' +
                        '<tr>' +
                        '<td class="price-tva" style="width:30px;text-align: left">' + gettextCatalog.getString("Total") + '</td>' +
                        '<td class="price-tva" style="width:30px"></td>' +
                        '<td class="price-tva">' + $filter('currencyFormatFilter')(totalVat) + '</td>' +
                        '<td class="price-tva">' + $filter('currencyFormatFilter')(totalHT) + '</td>' +
                        '<td class="price-tva">' + $filter('currencyFormatFilter')(totalTTC) + '</td>' +
                        '</tr>';
                }

                documentContent += '' +
                    '<tr>' +
                    '<td colspan="5" class="separator"></td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="4">' + gettextCatalog.getString("Règlement(s)") + '</td>' +
                    '<td></td>' +
                    '</tr>';

                if (this.advancePrice !== 0) {
                    documentContent += '' +
                        '<tr>' +
                        '<td colspan="5" class="separator"></td>' +
                        '</tr>' +
                        '<tr>' +
                        '<td colspan="4">' + gettextCatalog.getString("Montant de l\'acompte : ") + '</td>' +
                        '<td>' + $filter('currencyFormatFilter')(this.advancePrice) + '</td>' +
                        '</tr>';

                    documentContent += '' +
                        '<tr>' +
                        '<td colspan="4">' + gettextCatalog.getString("Taux : ") + '</td>' +
                        '<td>' + $filter('number')(Math.abs((this.advancePrice / this.price) * 100), 2) + '%</td>' +
                        '</tr>' +
                        '<tr>' +
                        '<td colspan="5" class="separator"></td>' +
                        '</tr>';
                }

                let payed = 0;
                let advanceNumberAdded = false;
                for (let i = 0; i < this.paymentsView.length; i++) {
                    documentContent += '' +
                        '<tr>' +
                        '<td>';

                    if (this.paymentsView[i].type !== 'UNPAID') {
                        documentContent += $filter('date')(this.paymentsView[i].date, 'shortDate');
                    }
                    documentContent += '</td><td colspan="3">';

                    let salePaymentType = SalePaymentTypeFactory.from(this.paymentsView[i].type);
                    if (salePaymentType) {
                        documentContent += salePaymentType.label;
                    } else if (this.paymentsView[i].otherPaymentTypeView) {
                        documentContent += this.paymentsView[i].otherPaymentTypeView.label;
                    }

                    if (!advanceNumberAdded && this.advanceNumber) {
                        documentContent += " " + gettextCatalog.getString("Acompte n°") + this.advanceNumber;
                        advanceNumberAdded = true;
                    }

                    documentContent += '' +
                        '</td>' +
                        '<td class="price">' + $filter('currencyFormatFilter')(this.paymentsView[i].price) + '</td>' +
                        '</tr>';
                    payed += this.paymentsView[i].price;
                }
                if ((this.price - payed > 0)) {
                    documentContent += '' +
                        '<tr>' +
                        '<td></td>' +
                        '<td colspan="3">' + gettextCatalog.getString("Reste à payer") + '</td>' +
                        '<td class="price">' + $filter('currencyFormatFilter')(this.price - payed) + '</td>' +
                        '</tr>';
                }

                documentContent += '' +
                    '<tr>' +
                    '<td colspan="5" class="separator"></td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="5" class="separator"></td>' +
                    '</tr>' +
                    '</table>';

                if (this.loyaltyCardItemView) {
                    documentContent += "<table class=\"loyalty\">";
                    documentContent += '<tr><td>' + gettextCatalog.getString("Fidélité") + '</td><td>' + this.loyaltyCardItemView.label + "</td></tr>";
                    if (this.loyaltyCardItemView.type !== "subs") {
                        documentContent += '<tr><td>' + gettextCatalog.getString("Nouveau solde") + '</td><td>' + this.totalLoyaltyPts + " pts</td></tr>";
                        documentContent += '<tr><td>' + gettextCatalog.getString("Ancien solde") + '</td><td>' + (this.totalLoyaltyPts - this.loyaltyPts) + " pts</td></tr>";
                        documentContent += '<tr><td>' + gettextCatalog.getString("Point cumulé") + '</td><td>' + (this.hasLoyaltyDiscount ? this.loyaltyPts + this.loyaltyCardItemView.goalPts : this.loyaltyPts) + " pts</td></tr>";
                        if (this.nbLoyaltyCardGoal <= 0) {
                            documentContent += "<tr><td>";

                            if ((this.loyaltyCardItemView.pts) < this.loyaltyCardItemView.goalPts) {
                                documentContent += gettextCatalog.getString("Prochaine récompense") + ' </td><td>' + this.loyaltyCardItemView.goalPts + " pts";
                            } else {
                                documentContent += gettextCatalog.getString("Au prochain achat") + '</td><td>';
                                if (this.loyaltyCardItemView.goalType === "special") {
                                    documentContent += this.loyaltyCardItemView.goalText;
                                } else {
                                    documentContent += "Remise de " + this.loyaltyCardItemView.computeGoalAmountNextSale();
                                    if (this.loyaltyCardItemView.goalType === "discountValue") {
                                        documentContent += " " + CurrencyManager.getCurrencySymbol();
                                    } else {
                                        documentContent += " %";
                                    }
                                }
                                documentContent += "</td></tr>";
                            }
                        }
                    }

                    if (this.loyaltyCardItemView.validityDate) {
                        documentContent += '<tr><td>' + gettextCatalog.getString("Validité") + '</td><td>' + $filter('date')(this.loyaltyCardItemView.validityDate, 'shortDate') + "</td></tr></table>";
                    }
                }

                //Specific text
                if (this.posView && this.posView.domainView.ticketEndText && this.posView.domainView.ticketEndText !== '' && !this.isEstimationCost()) {
                    documentContent += '<div>' + this.posView.domainView.ticketEndText + '</div>';
                } else if (this.isEstimationCost() && this.comment != null && this.comment !== "") {
                    documentContent += '<div>' + this.comment + '</div>';
                }

                for (let i = 0; i < this.giftItemsView.length; i++) {
                    if (this.giftItemsView[i].editionType !== "manual") {
                        documentContent += '<div style="border: 1px dotted black;margin: 5px;padding: 5px;text-align: center"><div style="font-size: 16px;padding-bottom: 3px">' + gettextCatalog.getString("Chèque cadeau de") + " " + $filter('currencyFormatFilter')(this.giftItemsView[i].originalPrice) + '</div><div><img id="barcode' + i + '"/></div><div>';
                        documentContent += this.giftItemsView[i].code;
                        documentContent += '</div><div>' + gettextCatalog.getString("Valable jusqu'au") + " " + $filter('date')(this.giftItemsView[i].validityDate, 'shortDate') + '</div></div><script>$(document).ready(function() {$("#barcode' + i + '").JsBarcode("';
                        documentContent += this.giftItemsView[i].code.replace(/-/g, "");
                        documentContent += '",{format:"EAN",displayValue:false,fontSize:16,height: 50});});</script>';
                    }
                }

                if (this.posView && this.posView.domainView.ticketEndDisplayBooking) {
                    let now = new Date();

                    if (this.customerView && this.customerView.globalHistoryView) {
                        let nextBooking = '<table class="bill" style="border: 1px dotted black;padding: 5px;text-align: center"><tr><th colspan="2" style="text-align:left">' + gettextCatalog.getString("Prochains rendez-vous") + '</th></tr>',
                            clonedHistory = this.customerView.globalHistoryView.copyWithin(0, 0),
                            hasNextBooking = false;

                        clonedHistory.sort(function (a, b) {
                            if (a.date < b.date) {
                                return -1;
                            }
                            if (a.date > b.date) {
                                return 1;
                            }
                            return 0;
                        });

                        for (let i = 0; i < clonedHistory.length; i++) {
                            let bookingTime = null;
                            if (clonedHistory[i].bookingPeriod && clonedHistory[i].bookingPeriod.start) {
                                bookingTime = clonedHistory[i].date.getTime() + clonedHistory[i].bookingPeriod.start.getTimeInMilli();
                            }

                            let filterdHistory = $filter('filter')(clonedHistory[i].items, {type: "service"});

                            if ((bookingTime && bookingTime > now.getTime()) && filterdHistory && filterdHistory.length != 0) {
                                hasNextBooking = true;
                                nextBooking += '<tr>' +
                                    '<td style="width:120px;vertical-align:top;text-align:left;">' + $filter('date')(clonedHistory[i].date, 'shortDate') + " " + gettextCatalog.getString("à") + " " + clonedHistory[i].bookingTime + '</td>' +
                                    '<td style="vertical-align:top;text-align:left;padding-left:5px">' +
                                    '<span>' + filterdHistory[0].label + '</span>';

                                for (let j = 1; j < filterdHistory.length; j++) {
                                    nextBooking += '<span>, ' + filterdHistory[j].label + '</span>';
                                }
                                nextBooking += '</td></tr>';
                            }
                        }
                        nextBooking += '</table>';
                        if (hasNextBooking) {
                            documentContent += nextBooking;
                        }
                    }
                }

                documentContent += '</div></body></html>';
                this.printWindow.document.write(documentContent);
                this.printWindow.document.title = gettextCatalog.getString("Imprimer");
                this.printWindow.document.close();
            }
        };

        SaleView.prototype.computeSoftV = function () {
            let softV;
            if (this.softV) {
                softV = this.softV.includes("backend") ? this.softV.substr(8) : this.softV;
                softV = softV.includes(".") ? softV.substr(0, softV.indexOf(".")) : softV;
            } else {
                softV = this.posView.domainView.scope.ad.loggedUser.serverIdentification.version;
            }
            return softV;
        };

        SaleView.prototype.updatePriceInputArrow = function (number) {
            if (this.canChangePriceDirectly()) {
                var originalPrice = this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice;
                if (number > 0 && this.price >= originalPrice)
                    return;
                var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
                var price = parseFloat(priceStr);
                if (isNaN(price))
                    this.form.displayErrorPrice = true;
                else {
                    this.form.displayErrorPrice = false;
                    price += number;
                }

                this.price = price;
                this.priceInput = $filter('currencyFormatFilter')(price);
                this.updatePercentOnPriceChange();
            }
        };

        SaleView.prototype.onPriceInputChange = function () {
            if (this.canChangePriceDirectly()) {
                let priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
                let price = parseFloat(priceStr);
                if (isNaN(price)) {
                    this.form.displayErrorPrice = true;
                    this.price = null;
                } else {
                    let originalPrice = this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice;
                    this.form.displayErrorPrice = price > originalPrice;
                    this.price = price;
                }
                this.updatePercentOnPriceChange();
            }
            this.checkForInvalidAmounts();
        };

        SaleView.prototype.canChangePriceDirectly = function () {
            if (!this.isReadOnly
                && this.priceInput != null
                && typeof this.priceInput === 'string'
                && !this.hasGiftItems
                && this.checkSalePartnerSettings(SaleSettings.UPDATE_PRICE)) {
                if (this.loyaltyCardItemView && this.nbLoyaltyCardGoal > 0 && this.loyaltyCardItemView.goalType != 'special') {
                    let opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/infoDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                let tableModel = [];
                                tableModel["label"] = gettextCatalog.getString("Vous ne pouvez pas changer le prix directement si une remise fidélité est appliquée.");
                                return tableModel;
                            }
                        }
                    };
                    $dialog.dialog(opts).open();
                    this.priceInput = $filter('currencyFormatFilter')(this.price);
                } else {
                    return true;
                }
            }
            return false;
        };

        SaleView.prototype.updatePercent = function () {
            const originalPrice = this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice;
            if (originalPrice !== 0) {
                this.discountPercent = Math.round(10000000 * (100 - 100 * this.price / originalPrice)) / 10000000;
            } else {
                this.discountPercent = 0;
            }
        };

        SaleView.prototype.updatePercentOnPriceChange = function () {
            this.updatePercent();

            this.resetPayments();
            this.calculateVatLines();
            this.currentPayment = this.price;
            this.currentPaymentInput = $filter('currencyFormatFilter')(this.currentPayment);
            this.calculateSaleFields(true);//force recalculate (to manage loyalty card by example) / Don't update priceinput
            if (this.discountPercent > 0)
                this.form.displayGlobalDiscount = true;
        };

        SaleView.prototype.displayDatePickerF = function () {
            if (this.status === "sold" || this.status === "canceled" || this.status === "credit")
                alert("Vous ne pouvez pas changer la date d'un ticket encaissé");
            else if (this.dayView)
                this.dayView.displayDatePickerF();
        };

        SaleView.prototype.onTechNoteSelection = function (minBookView) {
            if (minBookView) {
                this.techNote = minBookView.techNote;
            }
        };

        SaleView.prototype.isActiveGlobalDiscount = function () {
            return !(this.nbLoyaltyCardGoal > 0 && this.loyaltyCardItemView && (this.loyaltyCardItemView.goalType !== 'special'));
        };

        SaleView.prototype.isOnePaymentCalendarDisplayed = function () {
            let isOnePaymentCalendarDisplayed = false;
            for (let i = 0; i < this.paymentsView.length; i++) {
                if (this.paymentsView[i].datePickerOpened) {
                    isOnePaymentCalendarDisplayed = true;
                    break;
                }
            }
            return isOnePaymentCalendarDisplayed;
        };

        SaleView.prototype.manageOtherActionsMenu = function (displayMenu, indexPanel, title) {
            this.form.displayOtherActions = displayMenu;
            this.form.paymentActionsTab = indexPanel;
            if (this.form.paymentActionsTab === 0)
                this.form.nbPayments = 1;
            if (title == null)
                title = "";
            this.form.titleOtherActions = title;
            if (this.posView && this.posView.resizeBasketAfterAction)
                this.posView.resizeBasketAfterAction(!displayMenu);//animate only on close
        };

        SaleView.prototype.getNbPaymentInType = function (paymentType) {
            let nbPaymentInType = 0;
            for (let i = 0; i < this.paymentsView.length; i++) {
                if (paymentType && paymentType.label && this.paymentsView[i].otherPaymentTypeView) {
                    if (paymentType.label === this.paymentsView[i].otherPaymentTypeView.label) {
                        nbPaymentInType++;
                    }
                } else if (this.paymentsView[i].type === paymentType) {
                    nbPaymentInType++;
                }
            }
            return nbPaymentInType;
        };

        SaleView.prototype.createSaleFromEstimation = function () {
            this.status = 'created';
            this.calculateSaleFields(true);

            for (let i = 0; i < this.saleProductsView.length; i++) {
                let productView = this.saleProductsView[i].productView;
                if (productView.hasQuantity)
                    productView.quantity = productView.quantity - this.saleProductsView[i].quantity;
            }
        };

        SaleView.prototype.isEstimationCost = function () {
            return this.status === 'estimation';
        };

        SaleView.prototype.displaySaleLabel = function (statut) {

            let saleLabel = null;
            if (statut !== 'advance' && statut !== 'sold' && statut !== 'credit') {
                saleLabel = this.printLabel;
            } else {
                if (this.nbPrint >= 1) {
                    if (statut === 'advance') {
                        saleLabel = this.advanceDuplicataLabel + " " + (this.nbPrint);
                    } else if (statut === 'sold' || statut === 'credit') {
                        saleLabel = this.saleDuplicataLabel + " " + (this.nbPrint);
                    }
                } else {
                    if (statut === 'advance') {
                        saleLabel = this.originalAdvanceLabel;
                    } else if (statut === 'sold' || statut === 'credit') {
                        saleLabel = this.originalSaleLabel;
                    }
                }
            }

            return saleLabel;
        };

        SaleView.prototype.canCancelSale = function () {
            if (this.hasGiftItemUsed() || this.hasSaleCureWithUsage()) {
                return false;
            }

            let basicAuthRole = this.computeIfNeededAndGetBasicAuthRole();
            return !basicAuthRole || basicAuthRole.basicAuthRoleSaleCreationBehavior.cancelSale(this.status, this.paymentsView);
        };

        SaleView.prototype.checkSalePartnerSettings = function (setting) {
            let checkSalePartnerSettings = true;
            if (this.bookingView && this.bookingView.creator) {
                checkSalePartnerSettings = SalePartnerSettingsFactory.checkSalePartnerSettings(setting, this.bookingView.creator);
            }
            return checkSalePartnerSettings;
        };

        SaleView.prototype.computeIfNeededAndGetBasicAuthRole = function () {
            if (!this.basicAuthRole && this.bookingView) {
                this.basicAuthRole = this.basicAuthRoleFactory.getBasicAuthByBookingCreator(this.bookingView.creator);
            }
            return this.basicAuthRole;
        };

        SaleView.prototype.displaySaleAlert = function () {
            return this.computeIfNeededAndGetBasicAuthRole() && this.computeIfNeededAndGetBasicAuthRole().displaySaleAlert(this.status);
        };

        SaleView.prototype.canPartnerUpdatePayment = function () {
            return !this.computeIfNeededAndGetBasicAuthRole() || this.computeIfNeededAndGetBasicAuthRole().canPartnerUpdatePayment(this.status, this.checkSalePartnerSettings(SaleSettings.UPDATE_PAYMENT));
        };

        SaleView.prototype.updateRefundGiftItem = function () {
            let hasSaleProductsNoDelivery = false;
            for (let i = 0; i < this.saleProductsView.length; i++) {
                if (this.saleProductsView[i].productView) {
                    hasSaleProductsNoDelivery = true;
                    break;
                }
            }
            this.canRefundGiftItem = this.saleCuresView.length == 0 && (this.saleServicesView.length != 0 || hasSaleProductsNoDelivery || this.loyaltyCardItemsView.length != 0);
        };

        SaleView.prototype.checkForInvalidAmounts = function () {
            this.hasInvalidAmounts = this.areAmountsInvalid(this.price, this.discountPercent)
                || this.checkSaleItemsForInvalidAmounts(this.saleServicesView)
                || this.checkSaleItemsForInvalidAmounts(this.saleProductsView)
                || this.checkSaleItemsForInvalidAmounts(this.saleCuresView)
                || this.checkSaleItemsForInvalidAmounts(this.loyaltyCardItemsView)
                || this.checkSaleItemsForInvalidAmounts(this.giftItemsView);
        }

        SaleView.prototype.checkSaleItemsForInvalidAmounts = function (saleItemViews) {
            for (let saleItemView of saleItemViews) {
                if (this.areAmountsInvalid(saleItemView.originalPrice, saleItemView.discountPercent)) {
                    return true;
                }
            }
            return false;
        }

        SaleView.prototype.areAmountsInvalid = function (price, discountPercent) {
            return price == null || isNaN(price) || price < 0 || discountPercent == null || isNaN(discountPercent);
        }

        return SaleView;
    }]);



// WEBPACK FOOTER //
// ./js/services/views/SaleView.js